/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import { IconButton, InputBase, Typography, Button, Grid, Switch, TextField } from '@mui/material';
// import Grid from '@mui/material/Grid';
import { Box } from '@mui/system';
// import DropZone from '../../Components/DropZone';
// import PageLayout from '../../Components/PageLayout';
import DatePicker, { DateObject } from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import persian_en from "react-date-object/locales/persian_en";
// import { ReactComponent as CalendarIcon } from "../../Assets/svg/CalendarIcon.svg";
// import { ReactComponent as CopyIcon } from "../../Assets/svg/CopyIcon.svg";
// import { ReactComponent as ContactIcon } from "../../Assets/svg/ContactIcon.svg";
import { ReactComponent as FilterIcon } from "../../Assets/svg/FilterIcon.svg";
import { ReactComponent as NotificationIcon } from "../../Assets/svg/NotificationIcon.svg";
import { ReactComponent as ListIcon } from "../../Assets/svg/ListIcon.svg";
import { ReactComponent as CloseIcon } from "../../Assets/svg/CloseIcon.svg";
import { ReactComponent as HistoryIcon } from "../../Assets/svg/HistoryIcon.svg";
import { ReactComponent as ArrowRightIcon } from "../../Assets/svg/ArrowRightIcon.svg";
import { ReactComponent as SettingIcon } from "../../Assets/svg/SettingIcon.svg";
import { ReactComponent as LabelsSmallIcon } from "../../Assets/svg/LabelsSmallIcon.svg";
import { ReactComponent as LabelsSmallGreenIcon } from "../../Assets/svg/LabelsSmallGreenIcon.svg";
import { ReactComponent as FilterBtnGreenIcon } from "../../Assets/svg/FilterBtnGreenIcon.svg";
import { ReactComponent as FilterBtnIcon } from "../../Assets/svg/FilterBtnIcon.svg";
import { ReactComponent as CityIcon } from "../../Assets/svg/CityIcon.svg";
import { ReactComponent as SreachIcon } from "../../Assets/svg/SreachIcon.svg";

import data from '../../api/melkData.json';

import { InView } from "react-intersection-observer";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Slide from '@mui/material/Slide';
// import { PropertyContext } from '../../context/property-context';
// import data from '../../api/melkData.json';
// import Alert from '@mui/material/Alert';
// import Collapse from '@mui/material/Collapse';
// import Backdrop from '@mui/material/Backdrop';
// import CircularProgress from '@mui/material/CircularProgress';
import http from '../../api/axiosInstance';
import { NumericFormat } from 'react-number-format';
// import {
//     useParams
// } from "react-router-dom";
// import { TileLayer, useMapEvents, Marker, Popup, MapContainer } from 'react-leaflet'
import { useSnackbar } from 'notistack';
// import List from '@mui/material/List';
// import ListItem from '@mui/material/ListItem';
// import ListItemButton from '@mui/material/ListItemButton';
// import ListItemIcon from '@mui/material/ListItemIcon';
// import ListItemText from '@mui/material/ListItemText';
import ButtonNavigation from '../../Components/ButtonNavigation';
import PropItem from '../../Components/PropItem';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as PersonList } from "../../Assets/svg/PersonList.svg";
import { ReactComponent as DownloadIcon } from "../../Assets/svg/DownloadIcon.svg";
import { ReactComponent as PersonHome } from "../../Assets/svg/PersonHome.svg";
import { ReactComponent as PersonsCheckIcon } from "../../Assets/svg/PersonsCheckIcon.svg";
import { useSearchPropStore } from '../../store/searchProperty';
// import { useInView } from "react-intersection-observer";
import { useUserStore } from '../../store/user';
import ModalComponent from '../../Components/ModalComponent';
import UpdateModal from '../../Components/UpdateModal';
import { lightOrDark, reloadPageWithClearCache } from '../../Components/PublicFunctions';
import { dateTypes, priceItems, meterItems } from "../../api/ListData"
import moment from "moment-jalaali"
import {
    Picker,
    newDate,
    DatePickerConfig,
} from '@persian-tools/persian-mobile-datepicker';
import { config } from '../../Components/persian-mobile-datepicker-config'
import { scrollingDiv } from '../../Components/ScrollRightToLeftDrag'
import Cookies from 'js-cookie'
import SearchByUser from '../../Components/SearchByUser';
import { CheckPermissions } from '../../Components/CheckPermissions';
import {useMarket} from "../../context/MarketContext";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ py: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        className: 'tab-btn',
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const NumericFormatCustom = React.forwardRef(function NumericFormatCustom(
    props,
    ref,
) {
    const { onChange, ...other } = props;

    return (
        <NumericFormat
            {...other}
            getInputRef={ref}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator
            valueIsNumericString
            prefix=""
        />
    );
});

NumericFormatCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};





function Dashboard(props) {

    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const market = useMarket();

    const [tabValue, setTabValue] = React.useState(0);
    const [openSelectTypeModal, setOpenSelectTypeModal] = React.useState(false);
    const [openSelectTypeModalTmp, setOpenSelectTypeModalTmp] = React.useState(false);
    const [openCodeMelk, setOpenCodeMelk] = React.useState(false);
    const [openNameNumber, setOpenNameNumber] = React.useState(false);
    const [openMyOptions, setOpenMyOptions] = React.useState(false);
    const [openSortModal, setOpenSortModal] = React.useState(false);
    const [filterpayeshOrNotTitle, setFilterpayeshOrNotTitle] = React.useState("موارد خودم");
    const [properties, setProperties] = React.useState([]);
    const [propKey, setPropKey] = React.useState(0);
    const [properInPlusing, setProperInPlusing] = React.useState(true);
    const [moreSearchDataTmp, setMoreSearchDataTmp] = React.useState({
        IsArchived: "0"
    });
    const [nowDate, setNowDate] = React.useState("");

    const [totalCount, setTotalCount] = React.useState(0);
    const [hasMore, setHasMore] = React.useState(true);
    const [propLoading, setPropLoading] = React.useState(false);
    const [ofsset, setOfsset] = React.useState(0);
    const [searchRow, setSearchRow] = React.useState("");
    const [searchNameNumber, setSearchNameNumber] = React.useState("");
    const [updateModal, setUpdateModal] = React.useState(false);
    const [searchByLabelModal, setSearchByLabel] = React.useState(false);
    const [dateType, setDateType] = React.useState("");
    const [openDateTypeModal, setOpenDateTypeModal] = React.useState(false);
    const [labels, setLabels] = React.useState(false);
    const [labelsLoading, setLabelsLoading] = React.useState(false);
    const [opanHistoryModal, setOpanHistoryModal] = React.useState(false);
    const [changesVersion, setChangesVersion] = React.useState({});

    const [sortItem, setSortItem] = React.useState([
        ["قیمت از زیاد به کم", "DESC", "SalePrice"],
        ["قیمت از کم به زیاد", "ASC", "SalePrice"],
        ["زیربنا از زیاد به کم", "DESC", "Infrastructure"],
        ["زیربنا از کم به زیاد", "ASC", "Infrastructure"],
        ["مساحت از زیاد به کم", "DESC", "Space"],
        ["مساحت از کم به زیاد", "ASC", "Space"],
        ["اتاق از زیاد به کم", "DESC", "RoomsCount"],
        ["اتاق از کم به زیاد", "ASC", "RoomsCount"],
    ]);

    const [moreModal, setMoreModal] = React.useState(false);
    const [searchKey, setSearchKey] = React.useState(0);

    const dataFetchedRef = useRef(false);
    const searchData = useSearchPropStore((state) => state.searchData)
    const setSearchData = useSearchPropStore((state) => state.setSearchData)
    const emptySearchData = useSearchPropStore((state) => state.emptySearchData)
    const userInfo = useUserStore((state) => state.userInfo)
    const locationId = useUserStore((state) => state.locationId)
    const accessToken = useUserStore((state) => state.accessToken)
    const [searchByLabelList, setSearchByLabelList] = React.useState({});
    const appVersion = useUserStore((state) => state.appVersion)
    const setAppVersion = useUserStore((state) => state.setAppVersion)

    const [labelRadios, setLabelRadios] = React.useState([]);

    const propertySelected = useSearchPropStore((state) => state.propertySelected)
    const setPropertySelected = useSearchPropStore((state) => state.setPropertySelected)

    const [changeFlag, setChangeFlag] = React.useState(false);
    const [checkUsingFiling, setCheckUsingFiling] = React.useState(false);

    const limit = searchData.Limit
    const searchType = searchData.SearchType


    const [showSubmitDatePicker, setShowSubmitDatePicker] = React.useState(false);
    const [showMaxDatePicker, setShowMaxDatePicker] = React.useState(false);

    const [historyItems, setHistoryItems] = React.useState({});

    const navigation = useNavigate();

    const handleClickOkUsingFiling = async() => {

        try {

            const response1 = await http({
                url: "/clients/set/config",
                method: "POST",
                data: {
                    use_filing: true
                },
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            });
            if(response1.data.ok){
                const response = await http({
                    url: "/clients/get/config",
                    method: "GET",
                    headers: {
                        "Authorization": `Bearer ${Cookies.get('token')}`
                    }
                });
                if(response.data.ok && response.data.result){
                    const configRes = response.data.result.Config ?? {};

                    if(configRes.allow_app_permissions === true && configRes.use_filing === true){
                        setFilterpayeshOrNotTitle("موارد پایش");
                        setCheckUsingFiling(false);
                        navigation("/filing");
                    }
                    else if(configRes.use_filing === true){
                        window.location.href = "myapp://do/userPermissions";
                        setCheckUsingFiling(true);
                    }
                    else{
                        setCheckUsingFiling(true);
                    }
                }
                else{
                    console.error(response);
                }
            }
            else{
                console.error(response1);
            }
        }
        catch (e) {
            console.error(e);
        }

    }

    const handleClickCancelUsingFiling = async() => {
        try {
            const response = await http({
                url: "/clients/set/config",
                method: "POST",
                data: {
                    use_filing: false
                },
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            });
            if(response.data.ok){
                setCheckUsingFiling(false);
                setFilterpayeshOrNotTitle("موارد خودم")
                setSearchData({ name: 'FromDivar', value: "0" })
                handleOpenMyOptionsClose()
            }
            else{
                console.error(response);
            }
        }
        catch (e) {
            console.error(e);
        }
    }

    const handleClickMoreModal = () => {
        setMoreModal(true);
        var searchTmp = searchType
        emptySearchData()
        setSearchData({ name: "SearchType", value: searchTmp });
        scrollingDiv()

        setTimeout(function () { document.getElementById("floorNo-container").scroll(650, 0) }, 500)
    }
    const handleMoreModalClose = () => {
        setMoreModal(false);
    };

    const handleHistoryModalOpen = () => {
        setOpanHistoryModal(true)

        if (localStorage.getItem("searchHistory") && Object.keys(JSON.parse(localStorage.getItem("searchHistory"))).length) {
            setHistoryItems(JSON.parse(localStorage.getItem("searchHistory")))
            console.log("historyItems", historyItems)
        }
    }

    const handleRemoveFromHistory = (key) => {
        delete historyItems[key];
        localStorage.setItem("searchHistory", JSON.stringify(historyItems));
        setHistoryItems(JSON.parse(localStorage.getItem("searchHistory")))
    }
    const handleHistoryModalClose = () => {
        setOpanHistoryModal(false);
    };

    const handleRemoveFilters = () => {

        emptySearchData()
        setMoreSearchDataTmp(searchData)
        setSearchKey(searchKey => searchKey + 1)
        console.log("searchData", searchData)
        setTimeout(function () { document.getElementById("floorNo-container").scroll(650, 0) }, 500)


    };


    const handleSetMinRegisterDate = (selectedDate) => {
        
        handleSetMoreSearchDataTmp("MinRegisterDate", +selectedDate.date, false, false, false)
        const tmp = { ...searchByLabelList }        
    }

    const handleClickTmpRahnPriceModal = () => {
        setTmpRahnPriceModal(true);
    };

    const handleSaleTmpRahnModalClose = () => {
        setTmpRahnPriceModal(false);
    };

    const handleClickSelectMeterModal = () => {
        setSelectMeterModal(true);
        setShowPriceItem(1)
    };

    const handleSelectMeterModalClose = () => {
        setSelectMeterModal(false);
    };

    const handleClickSelectSpaceModal = () => {
        setSelectSpaceModal(true);
        setShowPriceItem(1)
    };

    const handleSelectSpaceSpaceClose = () => {
        setSelectSpaceModal(false);
    };

    const handleClickSelectYearModal = () => {
        setSelectYearModal(true);
        setShowYearItem(1)
    };

    const handleSelectYearModalClose = () => {
        setSelectYearModal(false);
    };


    const handleClickMelkType = () => {
        setMelkTypeModal(true);
    };

    const handleMelkTypeClose = () => {
        setMelkTypeModal(false);
    };

    const handleClickSelectTypeModal = () => {
        setOpenSelectTypeModal(true);
    };

    const handleSelectTypeModalClose = () => {
        setOpenSelectTypeModal(false);
    };

    const handleClickSelectTypeModalTmp = () => {
        setOpenSelectTypeModalTmp(true);
    };

    const handleSelectTypeModalTmpClose = () => {
        setOpenSelectTypeModalTmp(false);
    };

    const handleClickUpdateModal = () => {
        setUpdateModal(true);
    };

    const handleUpdateModalClose = () => {
        setUpdateModal(false);
    };

    const handleClickOpenOpenCodeMelk = () => {
        setOpenCodeMelk(true);
    };
    const handleCodeMelkClose = () => {
        setOpenCodeMelk(false);
    };

    const handleClickOpenNameNumber = () => {
        setOpenNameNumber(true);
    };
    const handleOpenNameNumberClose = () => {
        setOpenNameNumber(false);
    };

    const handleClickOpenMyOptions = () => {
        setOpenMyOptions(true);
    };
    const handleOpenMyOptionsClose = () => {
        setOpenMyOptions(false);
    };

    const handleClickOpenSortModal = () => {
        setOpenSortModal(true);
    };
    const handleOpenSortModalClose = () => {
        setOpenSortModal(false);
    };

    const handleClickTmpSalePriceModal = () => {
        setTmpSalePriceModal(true);
        setShowMeterItem(1)
    };

    const handleSaleTmpSalePriceModalClose = () => {
        setTmpSalePriceModal(false);
    };

    const handleClickTmpRentPriceModal = () => {
        setTmpRentPriceModal(true);
    };

    const handleSaleTmpRentModalClose = () => {
        setTmpRentPriceModal(false);
    };

    const handleSetMoreSearchDataTmp = (searchItem, value, isArray = false, isAppend = false, isToggle = false, closeFunc = () => { }) => {
        const tmp = { ...moreSearchDataTmp }
        console.log("searchItem", searchItem)

        if (isAppend) {
            !tmp[searchItem] ? tmp[searchItem] = [] : null
            if (tmp[searchItem].includes(value)) {
                const index = tmp[searchItem].indexOf(value);
                const newItem = tmp[searchItem].filter((item, index) => item != value);
                console.log("newItem", newItem)
                tmp[searchItem] = newItem
            } else {
                tmp[searchItem].push(value)
            }

        } else {
            if (!isArray) {
                if (!isToggle)
                    tmp[searchItem] = value
                else {
                    if (tmp[searchItem].includes(value)) {
                        const index = tmp[searchItem].indexOf(value);
                        const newItem = tmp[searchItem].filter((item, index) => item != value);
                        console.log("newItem", newItem)
                        tmp[searchItem] = newItem
                    } else {
                        tmp[searchItem] = [value]
                    }
                }
            }
            else tmp[searchItem] = [value]
        }

        setMoreSearchDataTmp(tmp)
        closeFunc()
        console.log("moreSearchDataTmp", moreSearchDataTmp)

    }

    const handleSearchByLabelModalOpen = async () => {
        setSearchByLabel(true);

        setLabelsLoading(true)
        try {
            http({
                url: "/webapp/labels",
                method: "POST",
                data: {
                    "Type": 1
                },
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {
                console.log("Count", res);
                setLabels(res.data.result.result)
                setLabelsLoading(false)

            });
        } catch (e) {
            console.error(e);
            setLabelsLoading(false)

        }

    };
    const handleSearchByLabelModalClose = () => {
        setSearchByLabel(false);
    };

    const handleClickOpenDateTypeModal = () => {
        setOpenDateTypeModal(true);
    };
    const handleCloseDateTypeModal = () => {
        setOpenDateTypeModal(false);
    };

    const handleSearchMore = () => {

        for (var item in moreSearchDataTmp) {

            console.log(Object.keys(moreSearchDataTmp).indexOf(item), Object.keys(moreSearchDataTmp).length)
            if (Object.keys(moreSearchDataTmp).length - 1 == Object.keys(moreSearchDataTmp).indexOf(item)) {
                console.log("moreSearchDataTmp", moreSearchDataTmp)
                setChangeFlag(true)
                setSearchData({ name: item, value: moreSearchDataTmp[item] });
            }
            else {
                setSearchData({ name: item, value: moreSearchDataTmp[item] });
            }
        }
        setOfsset(0)
        handleMoreModalClose()
    }

    const handleSetDateType = (e) => {
        console.log("e.target.value", e.target.value)
        setDateType(e.target.value)
        if (e.target.value != "بازه دلخواه") {
            let tmpDate = new Date(moment())
            const tmp = { ...searchByLabelList }
            if (e.target.value == "یک هفته اخیر")
                tmpDate = new Date(moment().subtract('days', 7))
            if (e.target.value == "پانزده روز اخیر")
                tmpDate = new Date(moment().subtract('days', 15))
            if (e.target.value == "یک ماه اخیر")
                tmpDate = new Date(moment().subtract('days', 30))
            if (e.target.value == "هفته جاری")
                tmpDate = new Date(moment().startOf('week').local('fa'))
            if (e.target.value == "ماه جاری")
                tmpDate = new Date(moment().startOf('jMonth').local('fa'))

            console.log("handleSetDateType date", +tmpDate.getTime())

            tmp["LabelStartDate"] = +tmpDate.getTime()
            tmp["LabelEndDate"] = new Date(moment()).getTime()
            setSearchByLabelList(tmp)

        } else {
            console.log("searchByLabelList['LabelStartDate']", searchByLabelList["LabelStartDate"])
            var d = new Date(moment())

            const tmpState = { ...searchByLabelList }
            tmpState["LabelStartDate"] = d.getTime()
            tmpState["LabelEndDate"] = ""

            setSearchByLabelList(tmpState)
        }
        handleCloseDateTypeModal()

    };
    const formatJalali = (timestamp) => {
        console.log("timestamp", timestamp)
        try {
            return timestamp ? moment.unix(parseInt(timestamp / 1000)).format("jYYYY/jMM/jDD") : timestamp
        } catch (e) {
            console.log("error", e)
            return timestamp;
        }
    }

    const disHandleSetDateType = (e) => {
        setDateType("")
    };

    const handleSetDate = (selectedDate) => {
        // let object = { date, format }

        // var dateSelected = new DateObject(object).convert(persian, persian_en).format()

        // var miladiDate = moment(dateSelected, 'jYYYY/jM/jD').format('YYYY-M-D')
        // console.log(miladiDate)
        // var d = new Date(miladiDate)

        const tmp = { ...searchByLabelList }
        tmp["LabelStartDate"] = +selectedDate.date
        setSearchByLabelList(tmp)
    }

    


    const handleSetMaxDate = (selectedDate) => {
        const tmp = { ...searchByLabelList }
        tmp["LabelEndDate"] = +selectedDate.date
        setSearchByLabelList(tmp)
    }

    const handleSetLabelForsearch = (state, label, e, index) => {
        console.log('change', e.target.checked)

        const tmp = { ...searchByLabelList }
        if (e.target.checked) {
            console.log('true', e.target.checked)
            let flag = false
            tmp["Labels"].map(item => {
                if (item.Id == label.Id) {
                    flag = true
                }
            })
            console.log("flag", flag)
            if (flag) {
                tmp["Labels"].map(item => {
                    if (item.Id == label.Id) {
                        item.State = state
                    }
                })
            }
            else
                tmp["Labels"][index] = {
                    "Id": label.Id,
                    "State": state
                }
        }
        else {
            console.log('false', e.target.checked)

            tmp["Labels"] = tmp["Labels"].filter(lab => lab.Id != label.Id)
            console.log('tmp["Labels"]', tmp["Labels"])
        }


        setSearchByLabelList(tmp)
        console.log("searchByLabelList", searchByLabelList)
    }

    const disHandleSetLabelForsearch = (e, label) => {
        console.log('dis', e)
        const tmp = { ...searchByLabelList }

        if (e.target.checked) {
            e.target.checked = false
            if (tmp["Labels"] && tmp["Labels"].length) {
                tmp["Labels"].map((item, index) => {
                    if (item.Id == label.Id)
                        tmp["Labels"] = tmp["Labels"].filter(lab => lab.Id != label.Id)
                })
            }
        }

    }

    const checkChecked = (id) => {
        console.log("item", id)
        searchByLabelList?.Labels.map(lab => {
            if (lab.Id == id)
                return true
        })

        return false
    }

    const handleSetUserLabel = (user) => {
        const tmp = { ...searchByLabelList }
        tmp['AssignedUser'] = user.Id
        tmp['fullName'] = user.username
        setSearchByLabelList(tmp)

        handleOpenUsersModalClose()
    }

    const handleSearchByLabel = async () => {

        handleSearchByLabelModalClose()

        const tmp = { ...searchByLabelList }
        tmp.LocationId = Cookies.get('locationId')
        tmp.AgencyInfo = true
        console.log("tmp", tmp)
        setSearchByLabelList(tmp)

        setPropLoading(true)
        setProperties([])
        try {
            await http({
                // url of the api endpoint (can be changed)
                url: "/properties/get/list/by/filter",
                method: "POST",
                data: tmp
            }).then((res) => {
                console.log("propres", res.data.result.Properties);


                if (res.data.result.Properties.length > 0) {

                    setProperties(res.data.result.Properties)

                    console.log("proper", properties)

                    setPropKey(propKey => propKey++)
                } else {

                    setProperties([])
                }
                setPropLoading(false)
            });

        } catch (e) {
            console.error(e);
            setPropLoading(false)
        }
    }

    const handleTabChange = (event, newValue) => {
        console.log("newValue", newValue)
        setTabValue(newValue);
    };

    const handleSetPayeshDownload = async (type = "IsMyOp") => {
        setChangeFlag(true)
        if (type == "IsMyOp") {
            setFilterpayeshOrNotTitle("موارد خودم")
            setSearchData({ name: 'FromDivar', value: "0" })
        }
        if (type == "IsPayesh") {

            if(market === "direct"){

                try {
                    const response = await http({
                        url: "/clients/get/config",
                        method: "GET",
                        headers: {
                            "Authorization": `Bearer ${Cookies.get('token')}`
                        }
                    });
                    console.log(response);
                    if(response.data.ok && response.data.result){
                        const configRes = response.data.result.Config ?? {};

                        if(configRes.allow_app_permissions === true && configRes.use_filing === true){
                            setFilterpayeshOrNotTitle("موارد پایش");
                            setCheckUsingFiling(false);
                            navigation("/filing");
                        }
                        else if(configRes.use_filing === true){
                            window.location.href = "myapp://do/userPermissions";
                            setCheckUsingFiling(true);
                        }
                        else{
                            setCheckUsingFiling(true);
                        }
                    }
                    else{
                        console.error(response);
                    }
                }
                catch (e) {
                    console.error(e);
                }
            }
            else{
                setFilterpayeshOrNotTitle("موارد پایش")
                navigation("/filing");
            }

        }
        console.log("searchData", searchData)
    }

    // useEffect(() => {
    //     if (dataFetchedRef.current) return;
    //     dataFetchedRef.current = true;
    //     try {
    //         http({
    //             // url of the api endpoint (can be changed)
    //             url: "/properties/get/list/by/filter",
    //             method: "POST",
    //             data: {
    //                 "LocationId": "439",
    //                 "AgencyId": ["b0f0bde0-5ece-11e6-86e0-c13167cdc53c"],
    //                 "Count": 1
    //             }
    //         }).then((res) => {
    //             console.log("Count", res.data.result.TotalCount);
    //             setTotalCount(res.data.result.TotalCount)
    //         });
    //     } catch (e) {
    //         console.error(e);
    //     }
    //     // getProperteis(6)
    // }, [])


    // const getProperteis = (limit = 10) => {
    //     console.log("totl", properties.length)


    //     console.log("getting", ofsset)
    //     setPropLoading(true)
    //     var searchItems = {}
    //     for (const item in searchData) {
    //         if (searchData[item] != "") {
    //             searchItems[item] = searchData[item]
    //         }
    //     }
    //     searchItems["Offset"] = ofsset
    //     try {
    //         http({
    //             // url of the api endpoint (can be changed)
    //             url: "/properties/get/list/by/filter",
    //             method: "POST",
    //             data: searchItems
    //         }).then((res) => {
    //             console.log("propres", res.data.result.Properties);
    //             const tmpProp = properties
    //             if (res.data.result.Properties.length > 0) {
    //                 res.data.result.Properties.map((item, index) => {
    //                     tmpProp.push(item)
    //                 })
    //                 setProperties(tmpProp)
    //                 console.log("proper", properties)
    //                 let newPropKey = propKey
    //                 setPropKey(newPropKey++)
    //             } else {
    //                 console.log("End")
    //                 setHasMore(false)
    //             }
    //             setPropLoading(false)
    //         });

    //     } catch (e) {
    //         console.error(e);
    //         setPropLoading(false)
    //     }
    // }

    const getProperties = async (resetState = false) => {
        console.log("getProperties", properties)
        if (resetState) {
            setProperties([])
            console.log("reset", properties)
            setPropKey(propKey => propKey++)
            setOfsset(0);
            setHasMore(true)
        }

        setPropLoading(true)
        var searchItems = {}
        for (const item in searchData) {
            if (searchData[item] != "") {
                searchItems[item] = searchData[item]
            }
        }
        searchItems["Offset"] = ofsset

        if (locationId){
            searchItems["LocationId"] = locationId
        }
        else{
            searchItems["LocationId"] = Cookies.get('locationId')
        }



        searchItems["LandLordInfo"] = true
        searchItems["SortOrder"] = "DESC"
        searchItems["AgencyId"] = [Cookies.get('agency') && JSON.parse(Cookies.get('agency')).Id]


        console.log("searchItems", searchItems)
        try {
            await http({
                // url of the api endpoint (can be changed)
                url: "/properties/get/list/by/filter",
                method: "POST",
                data: searchItems,
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {
                console.log("propres", res.data.result.Properties);

                const tmpProp = [...properties]
                if (res.data.result.Properties.length > 0) {
                    if (!resetState) {
                        res.data.result.Properties.map((item, index) => {
                            tmpProp.push(item)
                        })
                        setProperties(tmpProp)
                        console.log("resetState not")
                    }
                    else
                        setProperties(res.data.result.Properties)

                    console.log("proper", properties)

                    setPropKey(propKey => propKey++)
                } else {
                    console.log("End")
                    setHasMore(false)
                }
                setPropLoading(false)
                setChangeFlag(false)
                setTimeout(function () { setProperInPlusing(true) }, 1000)
                setTimeout(function () {
                    Array.from(document.querySelectorAll(".dash-property-item")).forEach(
                        (ele) => {
                            console.log("ele", ele)
                            ele.addEventListener("contextmenu", (e) => { e.preventDefault() });
                        })
                }, 1000)
                // if (propertySelected != "") {
                //     scrollOnElement()
                // }
            });

        } catch (e) {
            console.error(e);
            setPropLoading(false)
            setChangeFlag(false)

        }


    }


    // const onScroll = () => {
    //     if (typeof document.getElementById("dashboard-content") !== 'undefined' && document.getElementById("dashboard-content") !== null) {
    //         const scrollTop = document.getElementById("dashboard-content").scrollTop
    //         const scrollHeight = document.getElementById("dashboard-content").scrollHeight
    //         const clientHeight = document.getElementById("dashboard-content").clientHeight

    //         if (scrollTop + clientHeight >= scrollHeight && properInPlusing) {
    //             setProperInPlusing(false)

    //             setOfsset(ofsset => ofsset + limit);
    //             // setSearchData({"name":"Offset","value":ofsset})
    //             console.log("ofsset", ofsset)
    //         }
    //     }
    // }

    // useEffect(() => {
    //     setTimeout(function () {
    //         if (document && typeof document.getElementById("dashboard-content") !== 'undefined' && document.getElementById("dashboard-content") !== null && properties.length > 0) {
    //             document.getElementById("dashboard-content").addEventListener('scroll', onScroll)
    //             return () => document.getElementById("dashboard-content").removeEventListener('scroll', onScroll)
    //         }
    //     }, 500)

    // }, [properties])

    const handlePlusPropOffset = (inView) =>{
    console.log("🚀 ~ handlePlusPropOffset ~ inView:", inView)

        if (inView && !propLoading && hasMore) {
            setOfsset(ofsset => ofsset + limit);
        }
    } 

    useEffect(() => {
        console.log("offset use")

        if (hasMore && properties.length) {
            getProperties()
        }
    }, [ofsset])

    const handleCheckVersion = async () => {

        try {
            const response = await http({
                // url of the api endpoint (can be changed)
                url: "/webapp/version",
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            })

            console.log(response)
            if (!localStorage.getItem('appVersion') || localStorage.getItem('appVersion') != response.data.result.latest.version) {
                setChangesVersion({
                    additions: response.data.result.latest.description.additions ? response.data.result.latest.description.additions : [],
                    bug_fix: response.data.result.latest.description.bug_fix ? response.data.result.latest.description.bug_fix : []
                })
                setAppVersion(response.data.result.latest.version)
                handleClickUpdateModal()
            }

        } catch (e) {
            console.error(e);
        }
    }

    useEffect(() => {
        console.log("first use")
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;
        // emptySearchData()
        setFilterpayeshOrNotTitle("موارد خودم")
        setSearchData({ name: 'FromDivar', value: "0" })
        getProperties()

        const tmpSearchItems = [...sortItem]
        if (searchData.SearchType == "Sale") {
            tmpSearchItems[0][2] = "SalePrice"
            tmpSearchItems[1][2] = "SalePrice"

            console.log("searchData.SearchType", searchData.SearchType)
        }
        if (searchData.SearchType == "Rent") {
            tmpSearchItems[0][2] = "RentPrice1"
            tmpSearchItems[1][2] = "RentPrice1"
            console.log("searchData.SearchType", searchData.SearchType)
        }


        handleCheckVersion()


        const date = new Date()
        const fullDate = `${date.getDay()}/${date.getMonth()}/${date.getFullYear()}`
        const format = "YYYY"
        let object = { fullDate, format }
        const now = new DateObject(object).convert(persian, persian_en).format()
        setNowDate(now)
        for (let i = parseInt(now); i >= parseInt(now) - 51; i--) {

            const tmp = yearDates
            tmp.push(i)
            setYearDates(tmp)
        }




    }, [])

    const handleReloadPage = () => {
        localStorage.setItem('appVersion', appVersion)
        reloadPageWithClearCache()
    }

    useEffect(() => {

        console.log("searchData.SearchType", searchData.SearchType)

        const tmpSearchItems = [...sortItem]
        if (searchData.SearchType == "Sale") {
            tmpSearchItems[0][2] = "SalePrice"
            tmpSearchItems[1][2] = "SalePrice"
        }
        if (searchData.SearchType == "Rent") {
            tmpSearchItems[0][2] = "RentPrice1"
            tmpSearchItems[1][2] = "RentPrice1"
        }


    }, [searchData.SearchType])

    useEffect(() => {
        if (changeFlag) {
            getProperties(true)
            console.log('run use efect')
        }
    }, [searchData])

    useEffect(() => {

        console.log('searchByLabelList', searchByLabelList)

    }, [searchByLabelList])

    // useEffect(() => {
    //     console.log("Change", searchData)
    //     setProperties([])
    //     setOfsset(0);
    //     setPropLoading(true)
    //     var searchItems = {}
    //     for (const item in searchData) {
    //         if (searchData[item] != "") {
    //             searchItems[item] = searchData[item]
    //         }
    //     }
    //     searchItems["Offset"] = ofsset


    //     console.log("searchItems", searchItems)
    //     try {
    //         http({
    //             // url of the api endpoint (can be changed)
    //             url: "/properties/get/list/by/filter",
    //             method: "POST",
    //             data: searchItems
    //         }).then((res) => {
    //             console.log("propres", res.data.result.Properties);
    //             const tmpProp = properties
    //             if (res.data.result.Properties.length > 0) {
    //                 res.data.result.Properties.map((item, index) => {
    //                     tmpProp.push(item)
    //                 })
    //                 setProperties(tmpProp)
    //                 console.log("proper", properties)
    //                 let newPropKey = propKey
    //                 setPropKey(newPropKey++)
    //             } else {
    //                 console.log("End")
    //                 setHasMore(false)
    //             }
    //             setPropLoading(false)
    //         });

    //     } catch (e) {
    //         console.error(e);
    //         setPropLoading(false)
    //     }
    // }, [searchData])


    const handleSortByClick = (srtOrd, srtBy) => {
        setSearchData({ name: 'SortOrder', value: srtOrd })
        setChangeFlag(true)
        setSearchData({ name: 'SortBy', value: srtBy })
        handleOpenSortModalClose()
        console.log(searchData)
    }

    // const handleSetSortOrder = () => {

    //     getProperties(true)
    //     handleOpenSortModalClose()
    // }

    const handleEmptySearchData = () => {
        emptySearchData()
        console.log("serhData", searchData)
        console.log("serhData", searchData)
    }


    const handleClickOpenSanadModal = () => {
        setOpenSanadModal(true);
    };
    const handleCloseSanadModal = () => {
        setOpenSanadModal(false);
    };

    const handleClickOpenUserTypeModal = () => {
        setOpenUserTypeModal(true);
    };

    const handleCloseOpenUserTypeModal = () => {
        setOpenUserTypeModal(false);
    };



    const handleSearchByRow = async () => {

        if(!searchRow){
            enqueueSnackbar("هیچ کدی وارد نکرده اید", {variant: "info"});
            return;
        }

        setPropLoading(true)
        http({
            url: "/properties/get/by/row",
            method: "POST",
            data: {
                "Row": searchRow,
                "AgencyId": userInfo.Id,
                "LocationId": locationId,
                "CustomFields": ["Id"]
            }
        }).then((res) => {

            if (res.data.result.property) {
                navigate("/property/" + res.data.result.property.Id);
                handleCodeMelkClose()
            }
            else {
                enqueueSnackbar("خطا در جستجوی کد ملک", {variant: "error"});
            }
            setPropLoading(false)

        }).catch((e) => {
            if(e.response && e.response.status === 404){
                enqueueSnackbar("ملکی با این کد پیدا نشد", {variant: "info"});
            }
            else{
                enqueueSnackbar("خطا در برقراری ارتباط", {variant: "error"});
                console.error(e);
            }
            setPropLoading(false)
        });

    }

    const handleSearchByNameNumber = async () => {

        if(!searchNameNumber){
            enqueueSnackbar("هیچ مقداری وارد نکرده اید", {variant: "info"});
            return;
        }

        setPropLoading(true)
        http({
            url: "/properties/get/list/by/filter",
            method: "POST",
            data: {
                "LandLord": searchNameNumber,
                "AgencyId": userInfo.Id,
                "LocationId": locationId,
                "LandLordInfo": true,
                "AgencyInfo": true,
            },
            headers: {
                "Authorization": `Bearer ${Cookies.get('token')}`
            }
        }).then((res) => {

            handleOpenNameNumberClose()

            if (res.data.result.Properties.length > 0) {

                setProperties(res.data.result.Properties)
            }
            else {
                setProperties([])
            }

            setPropLoading(false)
        }).catch((e) => {
            console.error(e);
            setPropLoading(false)
            //setProperties([])
            //handleOpenNameNumberClose()
            enqueueSnackbar("خطا در بارگذاری ملک ها", {variant: "error"});
        });

    }

    const scrollOnElement = () => {
        console.log("propertySelected", propertySelected)
        var scrollDiv = document.getElementById(`#${propertySelected}`).offsetTop;
        document.getElementById(`#dashboard-content`).scrollTo({ top: scrollDiv, behavior: 'smooth' });
    }


    const handleDeletedProps = (id) => {
        let tmpProperties = [...properties]
        // console.log("tmpProperties",tmpProperties,properties)
        tmpProperties = tmpProperties.filter(item => item.Id != id)
        setProperties(tmpProperties)
    }



    ///////////////////////////////////////User Modal
    const [openUsersModal, setOpenUsersModal] = React.useState(false)
    const [labelsChecked, setLabelsChecked] = React.useState({})

    const [Users, setUsers] = React.useState([]);
    const [UserOffset, setUserOffset] = React.useState(0);
    const [HasMoreUsers, setHasMoreUsers] = React.useState(true);
    const [UsersLoading, setUsersLoading] = React.useState(false);
    const [inPlusingUser, setinPlusingUser] = React.useState(true);


    const getUsers = (resetState = false) => {
        if (resetState) {
            setUsers([])
            console.log("reset", Users)
            setPropKey(propKey => propKey++)
            setUserOffset(0);
            setHasMoreUsers(true)
        }

        setUsersLoading(true)
        try {
            http({
                // url of the api endpoint (can be changed)
                url: "/users/get-my-users",
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {
                console.log("users", res);

                const tmpProp = [...Users]
                if (res.data.result.Users.length > 0) {
                    if (!resetState) {
                        res.data.result.Users.map((item, index) => {
                            tmpProp.push(item)
                        })
                        setUsers(tmpProp)

                        setPropKey(propKey => propKey++)
                    }
                    else
                        setUsers(res.data.result.Users)


                    setPropKey(propKey => propKey++)

                } else {
                    console.log("End")
                    setHasMoreUsers(false)
                    if (resetState) setUsers([])

                }

                console.log("users ff", Users)
                setUsersLoading(false)
                setTimeout(function () { setinPlusingUser(true) }, 1000)
            });

        } catch (e) {
            console.error(e);
            setUsersLoading(false)

        }


    }


    const onUsersScroll = () => {
        if (document.getElementById("users-content")) {

            const scrollTop = document.getElementById("users-content").scrollTop
            const scrollHeight = document.getElementById("users-content").scrollHeight
            const clientHeight = document.getElementById("users-content").clientHeight
            if (scrollTop + clientHeight >= scrollHeight && inPlusingUser) {
                setUserOffset(UserOffset => UserOffset + 1);
                // setSearchData({"name":"Offset","value":UserOffset})
                console.log("UserOffset", UserOffset)
                setinPlusingUser(false)
            }
        }
    }

    useEffect(() => {
        setTimeout(function () {
            if (document && typeof document.getElementById("users-content") !== 'undefined' && document.getElementById("users-content") !== null && Users.length > 0) {
                console.log("Users Use")
                document.getElementById("users-content").addEventListener('scroll', onUsersScroll)
                return () => document.getElementById("users-content").removeEventListener('scroll', onUsersScroll)
            }
        }, 500)


    }, [Users])

    useEffect(() => {
        console.log("offset use")

        if (HasMoreUsers && Users.length) {
            getUsers()
        }
    }, [UserOffset])


    const handleClickOpenUsersModal = () => {


        getUsers(true)
        setTimeout(function () {
            if (document && typeof document.getElementById("users-content") !== 'undefined' && document.getElementById("users-content") !== null && Users.length > 0) {
                console.log("Users Use")
                document.getElementById("users-content").addEventListener('scroll', onUsersScroll)
                return () => document.getElementById("users-content").removeEventListener('scroll', onUsersScroll)
            }
        }, 500)
        setOpenUsersModal(true);
    };

    const handleOpenUsersModalClose = () => {
        setOpenUsersModal(false);
    };



    const handelEmptySearchRow = () => {
        setSearchRow("")
        getProperties(true)
    }

    const handelEmptySearchByLabelList = () => {
        setSearchByLabelList({})
        getProperties(true)
    }

    const handelEmptySearchType = () => {
        setChangeFlag(true)
        setOfsset(0)
        setSearchData({ name: "SearchType", value: 'Sale' })
        // getProperties(true)
    }



    const handlBooleanMoreSearchDataTemp = (searchItem, value) => {
        const tmp = { ...moreSearchDataTmp }

        if (tmp[searchItem] == "1") {
            tmp[searchItem] = "0"
            console.log("exits")
        }
        else {
            tmp[searchItem] = "1"
            console.log("not exits", searchItem)
        }
        setMoreSearchDataTmp(tmp)

        console.log("moreSearchDataTmp", moreSearchDataTmp)

    }


    const [melkTypeModal, setMelkTypeModal] = React.useState(false);
    const [melkTabValue, setMelkTabValue] = React.useState(0);
    const [tmpRahnPriceModal, setTmpRahnPriceModal] = React.useState(false);
    const [tmpRentPriceModal, setTmpRentPriceModal] = React.useState(false);
    const [tmpSalePriceModal, setTmpSalePriceModal] = React.useState(false);
    const [showPriceItem, setShowPriceItem] = React.useState(1);
    const [showMeterItem, setShowMeterItem] = React.useState(1);
    const [selectMeterModal, setSelectMeterModal] = React.useState(false);
    const [selectSpaceModal, setSelectSpaceModal] = React.useState(false);
    const [selectYearModal, setSelectYearModal] = React.useState(false);
    const [showYearItem, setShowYearItem] = React.useState(false);
    const [yearDates, setYearDates] = React.useState([]);
    const [openUserTypeModal, setOpenUserTypeModal] = React.useState(false);
    const [openSanadModal, setOpenSanadModal] = React.useState(false);


    const handleChangeMelkTabValue = (event, newValue) => {
        console.log("newValue", newValue)
        setMelkTabValue(newValue);
    };




    const CheckMoreSearch = () => {
        if (searchData.MinRegisterDate != "" || searchData.UsageTypes != "" || searchData.CertificateTypes != "" || searchData.SearchType != "Sale"
            || searchData.PropertyTypes != "" || searchData.MaxMortgagePrice != "" || searchData.MinMortgagePrice != ""
            || searchData.MaxRentPrice != "" || searchData.MinRentPrice != "" || searchData.MaxInfrastructure != "" || searchData.MinInfrastructure != ""
            || searchData.MaxSpace != "" || searchData.MinSpace != "" || searchData.MaxPropertyAgeYear != "" || searchData.MinPropertyAgeYear != "" || searchData.StoreyNo != ""
            || searchData.Parking != "" || searchData.Elevator != "" || searchData.Store != "" || searchData.MaxStoreyCount != "" || searchData.UsageTypes != ""
            || searchData.IsArchived == "1") {
            console.log("CheckMoreSearch false", searchData)
            return true
        }


        return false

    }



    const handelEmptyMoreSearch = () => {
        setChangeFlag(true)
        emptySearchData()

    }


      useEffect(() => {
            console.log("moreSearchDataTmp", moreSearchDataTmp)
    
        }, [moreSearchDataTmp])

    return (
        <>
            <Box className="gray-box rounded-20-bottom" sx={{ px: '20px', py: '10px', display: "flex", gap: '10px' }}>
                <IconButton onClick={handleHistoryModalOpen}>
                    <HistoryIcon />
                </IconButton>
                {/* <IconButton onClick={handleSearchByLabelModalOpen}>
                    <ListIcon />
                </IconButton> */}
{/*                <IconButton>
                    <NotificationIcon />
                </IconButton>*/}
                {/* <IconButton onClick={handleClickUpdateModal}>
                    <img src="/assets/img/info-icon.png" width="25px" />
                </IconButton> */}
            </Box>
            <Box id="dashboard-content" sx={{ pt: 2 }} >
                <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons={false}
                    aria-label="scrollable force tabs example"
                    className='tab-nav'
                    sx={{pl: 1}}
                    dir="rtl"
                >
                    <Tab icon={<FilterIcon />} className='tab-nav-item' onClick={handleClickOpenSortModal} sx={{ border: 'none!important', width: 'auto!important', minWidth: 'unset!important', paddingLeft: "0px!important" }} />
                    <Button className={`tab-nav-item ${CheckMoreSearch() && 'tab-active'}`} sx={{ display: "felx", alignItems: "center", gap: "10px", px: 2, minWidth: "unset!important" }}>
                        {CheckMoreSearch() ? <FilterBtnGreenIcon /> : <FilterBtnIcon />}
                        <Box onClick={handleClickMoreModal}>
                            فیلتر ها
                        </Box>
                        {CheckMoreSearch() ? <IconButton onClick={handelEmptyMoreSearch} sx={{ p: 0 }}><CloseIcon width='10px' /></IconButton> : ""}

                    </Button>
                    <Button className={`tab-nav-item ${searchData.SearchType != "Sale" && 'tab-active'}`} sx={{ display: "felx", alignItems: "center", gap: "10px", px: 2, minWidth: "unset!important" }}>
                        <Box onClick={handleClickSelectTypeModal}>
                            {searchData && searchData.SearchType && searchData.SearchType == "Sale" ? "نوع معامله" : ""}
                            {searchData && searchData.SearchType && searchData.SearchType == "Rent" ? "رهن" : ""}
                            {searchData && searchData.SearchType && searchData.SearchType == "Exchange" ? "معاوضه" : ""}
                            {searchData && searchData.SearchType && searchData.SearchType == "SalePreSale" ? "پیش فروش" : ""}
                            {searchData && searchData.SearchType && searchData.SearchType == "Associate" ? "مشارکت" : ""}
                        </Box>
                        {searchData.SearchType != "Sale" ? <IconButton onClick={handelEmptySearchType} sx={{ p: 0 }}><CloseIcon width='10px' /></IconButton> : ""}
                    </Button>
                    <Button className={`tab-nav-item ${Object.keys(searchByLabelList).length && 'tab-active'}`} sx={{ display: "felx", alignItems: "center", gap: "10px", px: 2, minWidth: "unset!important" }}>
                        {Object.keys(searchByLabelList).length ? <LabelsSmallGreenIcon /> : <LabelsSmallIcon />}
                        <Box onClick={handleSearchByLabelModalOpen}>
                            نشان شده ها
                        </Box>
                        {Object.keys(searchByLabelList).length != "" ? <IconButton onClick={handelEmptySearchByLabelList} sx={{ p: 0 }}><CloseIcon width='10px' /></IconButton> : ""}
                    </Button>
                    <Tab label={filterpayeshOrNotTitle} className='tab-nav-item' onClick={handleClickOpenMyOptions} />

                    {/* <Tab label={searchData.SearchType != "Sale" ? searchData.SearchType : "نوع معامله"} className={`tab-nav-item ${searchData.SearchType != "Sale" && 'tab-active'}`} onClick={handleClickSelectTypeModal} /> */}
                     <Tab label="کد ملک" className={`tab-nav-item`} onClick={handleClickOpenOpenCodeMelk} />
                    <Tab
                        label={<div>
                            <span>شماره/نام مالک</span>
                            {searchNameNumber != "" && <IconButton sx={{ p: '2px', marginRight: '5px' }} onClick={(e) => {
                                setSearchNameNumber("")
                                getProperties(true)
                                e.stopPropagation()
                            }}><CloseIcon height='12px' width='12px' /></IconButton>}
                        </div>}
                        className={`tab-nav-item ${searchNameNumber != "" && 'tab-active'}`}
                        onClick={handleClickOpenNameNumber}
                    />
                </Tabs>
                <Box sx={{ px: 3, py: 1 }} >
                    {
                        properties && properties.length > 0 ?
                            properties.map((item, index) => (
                                <PropItem key={index} propInfo={item} handleDeletedProps={handleDeletedProps} />
                            ))
                            : !propLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""
                    }
                    {
                        propLoading ? <Box sx={{ textAlign: 'center' }}>درحال بارگیری...</Box> : ""

                    }
                    <InView
                        as='div'
                        onChange={(inView, entry) =>
                            handlePlusPropOffset(inView, entry)
                        }></InView>
                </Box>
            </Box>
            <ButtonNavigation />

            {openSelectTypeModalTmp && <Dialog className="dialog-box"
                fullScreen
                open={openSelectTypeModalTmp}
                onClose={handleSelectTypeModalTmpClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                            {/* انتخاب کنید */}
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleSelectTypeModalTmpClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', pt: 3, gap: '20px', px: 4 }}>
                    <Button className="inputs-container border-0"
                        sx={{ width: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#E8E5FE!important', py: 1, px: 2 }} onClick={(e) => handleSetMoreSearchDataTmp("SearchType", "Sale", false, false, false, handleSelectTypeModalTmpClose)}
                    >
                        <Box className="flex-1" sx={{ color: '#707070' }}>فروش</Box>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Button>
                    <Button className="inputs-container border-0" sx={{ width: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#FAF3C0!important', py: 1, px: 2 }} onClick={(e) => handleSetMoreSearchDataTmp("SearchType", "Rent", false, false, false, handleSelectTypeModalTmpClose)}>
                        <Box className="flex-1" sx={{ color: '#707070' }}>رهن و اجاره</Box>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Button>
                    <Button className="inputs-container border-0" sx={{ width: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#FFCAA1!important', py: 1, px: 2 }} onClick={(e) => handleSetMoreSearchDataTmp("SearchType", "Exchange", false, false, false, handleSelectTypeModalTmpClose)}>
                        <Box className="flex-1" sx={{ color: '#707070' }}>معاوضه</Box>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Button>
                    <Button className="inputs-container border-0" sx={{ width: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#D6ECD2!important', py: 1, px: 2 }} onClick={(e) => handleSetMoreSearchDataTmp("SearchType", "SalePreSale", false, false, false, handleSelectTypeModalTmpClose)}>
                        <Box className="flex-1" sx={{ color: '#707070' }}>پیش خرید</Box>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Button>
                    <Button className="inputs-container border-0" sx={{ width: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#BDECF3!important', py: 1, px: 2 }} onClick={(e) => handleSetMoreSearchDataTmp("SearchType", "Associate", false, false, false, handleSelectTypeModalTmpClose)}>
                        <Box className="flex-1" sx={{ color: '#707070' }}>مشارکت</Box>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Button>
                </Box>
                {/* <Button
                    onClick={handleSelectTypeModalClose}
                    className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button> */}
            </Dialog>}

            <Dialog className="dialog-box"
                fullScreen
                open={openSelectTypeModal}
                onClose={handleSelectTypeModalClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                            {/* انتخاب کنید */}
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleSelectTypeModalClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', pt: 3, gap: '20px', px: 4 }}>
                    <Button className="inputs-container border-0"
                        sx={{ width: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#E8E5FE!important', py: 1, px: 2 }}
                        onClick={() => {
                            setChangeFlag(true)
                            setSearchData({ name: "SearchType", value: 'Sale' })
                            handleSelectTypeModalClose()
                            navigation("/search-property")
                        }} >
                        <Box className="flex-1" sx={{ color: '#707070' }}>فروش</Box>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Button>
                    <Button className="inputs-container border-0" onClick={() => {
                        setChangeFlag(true)
                        setSearchData({ name: "SearchType", value: 'Rent' })
                        handleSelectTypeModalClose()
                        navigation("/search-property")
                    }} sx={{ width: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#FAF3C0!important', py: 1, px: 2 }}>
                        <Box className="flex-1" sx={{ color: '#707070' }}>رهن و اجاره</Box>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Button>
                    <Button className="inputs-container border-0" sx={{ width: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#FFCAA1!important', py: 1, px: 2 }} onClick={() => {
                        setChangeFlag(true)
                        setSearchData({ name: "SearchType", value: 'Exchange' })
                        handleSelectTypeModalClose()
                        navigation("/search-property")
                    }}>
                        <Box className="flex-1" sx={{ color: '#707070' }}>معاوضه</Box>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Button>
                    <Button className="inputs-container border-0" sx={{ width: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#D6ECD2!important', py: 1, px: 2 }} onClick={() => {
                        setChangeFlag(true)
                        setSearchData({ name: "SearchType", value: 'SalePreSale' })
                        handleSelectTypeModalClose()
                        navigation("/search-property")
                    }}>
                        <Box className="flex-1" sx={{ color: '#707070' }}>پیش فروش</Box>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Button>
                    <Button className="inputs-container border-0" sx={{ width: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#BDECF3!important', py: 1, px: 2 }} onClick={() => {
                        setChangeFlag(true)
                        setSearchData({ name: "SearchType", value: 'Associate' })
                        handleSelectTypeModalClose()
                        navigation("/search-property")
                    }}>
                        <Box className="flex-1" sx={{ color: '#707070' }}>مشارکت</Box>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Button>
                </Box>
            </Dialog>
            <Dialog className="dialog-box"
                fullScreen
                open={openCodeMelk}
                onClose={handleCodeMelkClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                            {/* انتخاب محدوده */}
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleCodeMelkClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box sx={{ px: 2, mt: 3, color: '#8F8F8F' }}>
                    <Box>
                        <Box className="inputs-container" sx={{ width: 'auto' }}>
                            <InputBase id='meter' value={searchRow} onChange={(e) => setSearchRow(e.target.value)} placeholder='کد ملک مورد نظر خود را وارد کنید' />
                        </Box>
                    </Box>
                </Box>
                <Button className='green-btn' startIcon={propLoading ? <img src="/assets/img/ladng2.gif" width="25" style={{marginLeft: '10px'}} /> : ""}
                        disabled={propLoading} onClick={handleSearchByRow} sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px', borderRadius: 0 }}>انتخاب</Button>
            </Dialog>

            <Dialog className="dialog-box"
                fullScreen
                open={openNameNumber}
                onClose={handleOpenNameNumberClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                            {/* انتخاب محدوده */}
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleOpenNameNumberClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box sx={{ px: 2, mt: 3, color: '#8F8F8F' }}>

                    <Box>
                        <Box className="inputs-container" sx={{ width: 'auto' }}>
                            <InputBase id='meter' value={searchNameNumber} onChange={(e) => setSearchNameNumber(e.target.value)} placeholder='شماره یا نام مالک را وارد کنید' />
                        </Box>
                    </Box>
                </Box>
                <Button className='green-btn' onClick={handleSearchByNameNumber} sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>جستجو</Button>
            </Dialog>

            <Dialog className="dialog-box"
                fullScreen
                open={openMyOptions}
                onClose={handleOpenMyOptionsClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>
                        <IconButton>
                            <SettingIcon />
                        </IconButton>
                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                            {/* انتخاب محدوده */}
                        </Typography>

                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleOpenMyOptionsClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px', mt: 2, paddingBottom: '80px', px: 2 }}>
                    <Box>
                        <input type="radio" name='propType' id="myOptions" className="d-none typeCheck" checked={filterpayeshOrNotTitle == "موارد خودم" ? true : false} value="موارد خودم" onChange={() => handleSetPayeshDownload("IsMyOp")} />
                        <label htmlFor="myOptions" className='typeLabel w-auto justify-content-right gap-10'>
                            <PersonList />
                            موارد خودم
                        </label>
                    </Box>
                    <Box>
                        <input type="radio" name='propType' id="daryafti" className="d-none typeCheck" checked={filterpayeshOrNotTitle == "موارد پایش" ? true : false} value="موارد دریافتی از پایش" onChange={() => handleSetPayeshDownload("IsPayesh")} />
                        <label htmlFor="daryafti" className='typeLabel w-auto justify-content-right gap-10'>
                            <DownloadIcon />
                            موارد دریافتی از پایش
                        </label>
                    </Box>
                    {checkUsingFiling && <Box sx={{}}>
                        برای استفاده از قسمت فایلینگ نیاز هست دسترسی های بیشتری به اپلیکیشن بدهید.<br />
                        از این دسترسی ها جهت استخراج فایل ها استفاده می شود.<br />
                        ممکن است مقدار کمی از اینترنت شما جهت استخراج فایل ها مصرف شود.<br />
                        <br />
                        <Box sx={{ display: 'flex', gap: '15px', justifyContent: 'end', marginBottom: '15px' }}>
                            <Button className='green-btn' onClick={handleClickOkUsingFiling}>باشه</Button>
                            <Button className='gray-btn' onClick={handleClickCancelUsingFiling}>نمی خواهم</Button>
                        </Box>
                    </Box>}
                    <Box>
                        <input type="radio" name='propType' id="amlak" className="d-none typeCheck" value="موارد مشاورین املاک" />
                        <label htmlFor="amlak" className='typeLabel w-auto justify-content-right gap-10'>
                            <PersonHome />
                            موارد مشاورین املاک
                        </label>
                    </Box>
                    <Box>
                        <input type="radio" name='propType' id="montakhab" className="d-none typeCheck" value="موارد همکاران منتخب" />
                        <label htmlFor="montakhab" className='typeLabel w-auto justify-content-right gap-10'>
                            <PersonsCheckIcon />
                            موارد همکاران منتخب
                        </label>
                    </Box>
                </Box>
                <Button className='green-btn' onClick={handleOpenMyOptionsClose} sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>جستجو</Button>
            </Dialog>

            <Dialog className="dialog-box"
                fullScreen
                open={openSortModal}
                onClose={handleOpenSortModalClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>
                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                            مرتب سازی
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleOpenSortModalClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box sx={{ px: 2, mt: 3, color: '#8F8F8F' }}>
                    {
                        <Box>
                            {
                                sortItem.map((item, index) => {
                                    return <Box className="price-item" key={index}>
                                        <input type="radio" name="minPrice" id={`min-${index}`} className="d-none" />
                                        <Button className='w-100 d-block' sx={{ textAlign: 'right' }} onClick={() => handleSortByClick(item[1], item[2])}>
                                            <label htmlFor={`min-${index}`} className='w-100 d-block'>
                                                {item[0]}
                                            </label>
                                        </Button>
                                    </Box>
                                })
                            }
                        </Box>
                    }
                </Box>
                {/* <Button onClick={handleSetSortOrder} className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button> */}
            </Dialog>

            {updateModal && <ModalComponent showModalState={updateModal}
                handleModalClose={handleUpdateModalClose}
                modalTitle="بروزرسانی ها"
                modalSubmitBtn={handleReloadPage}
                modalTitleSubmitBtn="اعمال بروزرسانی ها"
                hasSpecificParent={true}>
                <UpdateModal changesVersion={changesVersion} />
            </ModalComponent>}

            {searchByLabelModal && <Dialog className="dialog-box"
                fullScreen
                open={searchByLabelModal}
                onClose={handleSearchByLabelModalClose}
                TransitionComponent={Transition}
            >
                <Box>
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666', width: '100%', position: 'fixed', top: '0px' }}>
                        <Toolbar sx={{ bgcolor: '#fff' }}>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                {/* انتخاب محدوده */}
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleSearchByLabelModalClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                        </Toolbar>
                    </AppBar>

                    <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px', mt: 2, paddingBottom: '80px', px: 2 }} >

                        <Box sx={{ width: '100%' }}>
                            <Box className="inputs-container" sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }} onClick={handleClickOpenDateTypeModal}>
                                <span>
                                    {dateType == "" ? "تعیین تاریخ" : dateType}
                                </span>
                                <ArrowRightIcon className='rotate-180-minus' />
                            </Box>
                        </Box>
                        {dateType == "بازه دلخواه" && <Box sx={{ width: '100%' }}>
                            <label htmlFor='meter' className='f-16 text-label'>از تاریخ</label>
                            <Box className="inputs-container" sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                <div className='flex-1 w-chile-100'>
                                    {/* <DatePicker calendar={persian} placeholder="تعیین تاریخ"
                                        locale={persian_fa} onChange={handleSetDate}  value={new Date()} /> */}
                                    <InputBase value={formatJalali(searchByLabelList["LabelStartDate"])} className='flex-1' onClick={() => setShowSubmitDatePicker(true)} />
                                    <Picker
                                        isOpen={showSubmitDatePicker}
                                        config={config}
                                        value={searchByLabelList["LabelStartDate"]}
                                        initialValue={new Date(searchByLabelList["LabelStartDate"] ? new Date(searchByLabelList["LabelStartDate"]) : new Date())}
                                        minDate={newDate({ year: parseInt(moment().format("jYYYY")) - 100, month: 1, day: 1 })}
                                        maxDate={newDate({ year: parseInt(moment().format("jYYYY")), month: 12, day: 29 })}
                                        onSubmit={handleSetDate}
                                        // onChange={handleSetDate}
                                        onClose={() => {
                                            setShowSubmitDatePicker(false)

                                        }}
                                        highlightWeekends
                                    />
                                </div>
                                <ArrowRightIcon className='rotate-180-minus' />
                            </Box>
                        </Box>}
                        {dateType == "بازه دلخواه" && <Box sx={{ width: '100%' }}>
                            <label htmlFor='meter' className='f-16 text-label'>تا تاریخ</label>

                            <Box className="inputs-container" sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                <div className='flex-1 w-chile-100'>
                                    {/* <DatePicker calendar={persian} placeholder="تعیین تاریخ"
                                        locale={persian_fa} onChange={handleSetDate}  value={new Date()} /> */}
                                    <InputBase value={formatJalali(searchByLabelList["LabelEndDate"])} className='flex-1' onClick={() => setShowMaxDatePicker(true)} />
                                    <Picker
                                        isOpen={showMaxDatePicker}
                                        config={config}
                                        initialValue={new Date(searchByLabelList["LabelEndDate"] ? new Date(searchByLabelList["LabelEndDate"]) : new Date())}
                                        minDate={newDate({ year: parseInt(moment().format("jYYYY")), month: 1, day: 1 })}
                                        maxDate={newDate({ year: parseInt(moment().format("jYYYY")) + 10, month: 12, day: 29 })}
                                        onSubmit={handleSetMaxDate}
                                        // onChange={handleSetMaxDate}
                                        onClose={() => setShowMaxDatePicker(false)}
                                        highlightWeekends
                                    />
                                </div>
                                <ArrowRightIcon className='rotate-180-minus' />
                            </Box>
                        </Box>}
                        <Box sx={{ width: '100%', display: "flex", flexDirection: "column", gap: '10px' }}>
                            {
                                labels && labels.length ?
                                    labels.map((item, index) =>
                                        <Box key={index}>
                                            <label htmlFor='meter' className='f-16 text-label'>{item.Text}</label>
                                            <Box className="label-item" sx={{ width: 'auto', mt: 1, display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                                <Box sx={{ bgcolor: item.ColorCode, color: lightOrDark(item.ColorCode) == "light" ? "#5a5a5a!important" : "#fff!important" }}>
                                                    <input type="radio" name={`label${index}`} id={`label-${index}-0`} className="d-none typeCheck" checked={searchByLabelList?.Labels && searchByLabelList?.Labels[index] && searchByLabelList?.Labels[index]?.State == 1} onChange={(e) => handleSetLabelForsearch(1, item, e, index)} />
                                                    <label htmlFor={`label-${index}-0`} className={`typeLabel border-0 darkLabel ${lightOrDark(item.ColorCode) == "light" ? "" : "darkLabel"}`}>
                                                        نشان شده
                                                    </label>
                                                </Box>
                                                <Box sx={{ borderColor: `${item.ColorCode}!important`, color: "#5a5a5a!important" }}>
                                                    <input type="radio" name={`label${index}`} id={`label-${index}-1`} className="d-none typeCheck" checked={searchByLabelList?.Labels && searchByLabelList?.Labels[index] && searchByLabelList?.Labels[index]?.State == 0} onChange={(e) => handleSetLabelForsearch(0, item, e, index)} />
                                                    <label htmlFor={`label-${index}-1`} className='typeLabel border-0'>
                                                        بدون نشان
                                                    </label>
                                                </Box>
                                            </Box>
                                        </Box>
                                    )
                                    : !labelsLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""}

                            {labelsLoading ? <Box sx={{ textAlign: 'center' }}>درحال بارگیری...</Box> : ""}

                        </Box>
                        <Box>
                            <label htmlFor='meter' className='f-16 text-label'>کاربر</label>
                            <Box className={`inputs-container`} onClick={() => handleClickOpenUsersModal()} sx={{ width: 'auto', mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', bgcolor: "#fff" }}>
                                <span>{searchByLabelList.fullName ? searchByLabelList.fullName : ""}</span>
                                <ArrowRightIcon className='rotate-90' />
                            </Box>
                        </Box>
                    </Box>
                    <Button
                        onClick={handleSearchByLabel}
                        className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>مشاهده نتایج</Button>
                </Box>
            </Dialog>}

            {openDateTypeModal && <Dialog className="dialog-box"
                fullScreen
                open={openDateTypeModal}
                onClose={handleCloseDateTypeModal}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                            انتخاب کنید
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleCloseDateTypeModal}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px' }}>

                    <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>
                        {dateTypes.map((item, index) => (
                            <Box sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                <input type="radio" id={`sanad${index}`} className="d-none typeCheck" checked={dateType != "" && dateType == item.value} value={item.value} onChange={handleSetDateType} onClick={disHandleSetDateType} />
                                <label htmlFor={`sanad${index}`} className='typeLabel check-has-arrow'>
                                    {item.title}
                                </label>
                            </Box>
                        ))}
                    </Box>
                </Box>
                {/* <Button
                    onClick={handleCloseDateTypeModal}
                    className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button> */}
            </Dialog>}

            {openUsersModal && <Dialog className="dialog-box"
                fullScreen
                open={openUsersModal}
                onClose={handleOpenUsersModalClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                            کاربران
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleOpenUsersModalClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', height: "calc(100vh - 140px)!important", overflow: "auto" }} id="uset-content">
                    <Box >
                        <Box sx={{ display: "flex", flexDirection: "column", gap: '15px', mt: "15px" }}>
                            {
                                Users && Users.length > 0 ?
                                    Users.map((item, index) => (

                                        <Button className="inputs-container has-arrow" sx={{ display: "flex", justifyContent: "space-between", width: "100%", p: 1 }} onClick={() => handleSetUserLabel(item)} key={index}>
                                            <Box sx={{ display: "flex", gap: '5px', alignItems: 'center' }}>

                                                <Typography component="span">{item?.username}</Typography>
                                            </Box>
                                            {/* <IconButton>
                                                <PenIcon2 />
                                            </IconButton> */}
                                        </Button>

                                    ))
                                    : !UsersLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""
                            }
                            {
                                UsersLoading ? <Box sx={{ textAlign: 'center' }}>درحال بارگیری...</Box> : ""
                            }

                        </Box>
                    </Box>
                </Box>
                {/* <Button className='green-btn' onClick={handleOpenUsersModalClose} sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>ثبت</Button> */}
            </Dialog>}



            {moreModal && <Dialog className="dialog-box"
                fullScreen
                open={moreModal}
                onClose={handleMoreModalClose}
                TransitionComponent={Transition}
            >
                <Box key={searchKey}>
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666', width: '100%', position: 'fixed', top: '0px' }}>
                        <Toolbar sx={{ bgcolor: '#fff' }}>
                            <Button sx={{ bgcolor: '#8F8F8F!important', fontSize: '11px', color: '#fff' }} className="rounded-50" onClick={handleRemoveFilters}>
                                حذف فیلتر ها
                            </Button>
                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                {/* انتخاب محدوده */}
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleMoreModalClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                        </Toolbar>
                    </AppBar>

                    <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px', mt: 2, paddingBottom: '80px', px: 2 }} key={searchKey}>

                        <Box sx={{ width: '100%' }}>
                            <Box className="inputs-container" sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }} onClick={handleClickOpenDateTypeModal}>
                                <span>
                                    {dateType == "" ? "تعیین تاریخ" : dateType}
                                </span>
                                <ArrowRightIcon className='rotate-180-minus' />
                            </Box>
                        </Box>
                        {dateType == "بازه دلخواه" && <Box sx={{ width: '100%' }}>
                            <label htmlFor='meter' className='f-16 text-label'>از تاریخ</label>
                            <Box className="inputs-container" sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                <div className='flex-1 w-chile-100'>
                                    {/* <DatePicker calendar={persian} placeholder="تعیین تاریخ"
                                        locale={persian_fa} onChange={handleSetDate}  value={new Date()} /> */}
                                    <InputBase value={formatJalali(moreSearchDataTmp["MinRegisterDate"])} className='flex-1' onClick={() => setShowSubmitDatePicker(true)} />
                                    <Picker
                                        isOpen={showSubmitDatePicker}
                                        config={config}
                                        value={moreSearchDataTmp["MinRegisterDate"]}
                                        initialValue={new Date(moreSearchDataTmp["MinRegisterDate"] ? new Date(moreSearchDataTmp["MinRegisterDate"]) : new Date())}
                                        minDate={newDate({ year: parseInt(moment().format("jYYYY")) - 100, month: 1, day: 1 })}
                                        maxDate={newDate({ year: parseInt(moment().format("jYYYY")), month: 12, day: 29 })}
                                        onSubmit={handleSetMinRegisterDate}
                                        // onChange={handleSetDate}
                                        onClose={() => setShowSubmitDatePicker(false)}
                                        highlightWeekends
                                    />
                                </div>
                                <ArrowRightIcon className='rotate-180-minus' />
                            </Box>
                        </Box>}
                        {dateType == "بازه دلخواه" && <Box sx={{ width: '100%' }}>
                            <label htmlFor='meter' className='f-16 text-label'>تا تاریخ</label>

                            <Box className="inputs-container" sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                <div className='flex-1 w-chile-100'>
                                    {/* <DatePicker calendar={persian} placeholder="تعیین تاریخ"
                                        locale={persian_fa} onChange={handleSetDate}  value={new Date()} /> */}
                                    <InputBase value={formatJalali(moreSearchDataTmp["MaxRegisterDate"])} className='flex-1' onClick={() => setShowMaxDatePicker(true)} />
                                    <Picker
                                        isOpen={showMaxDatePicker}
                                        config={config}
                                        initialValue={new Date(moreSearchDataTmp["MaxRegisterDate"] ? new Date(moreSearchDataTmp["MaxRegisterDate"]) : new Date())}
                                        minDate={newDate({ year: parseInt(moment().format("jYYYY")), month: 1, day: 1 })}
                                        maxDate={newDate({ year: parseInt(moment().format("jYYYY")) + 10, month: 12, day: 29 })}
                                        onSubmit={handleSetMaxDate}
                                        // onChange={handleSetMaxDate}
                                        onClose={() => setShowMaxDatePicker(false)}
                                        highlightWeekends
                                    />
                                </div>
                                <ArrowRightIcon className='rotate-180-minus' />
                            </Box>
                        </Box>}

                        <Box sx={{ width: '100%' }}>
                            <label htmlFor='meter' className='f-16 text-label'>نوع معامله</label>
                            <Box className="inputs-container" onClick={handleClickSelectTypeModalTmp} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                <Box>
                                    {moreSearchDataTmp && moreSearchDataTmp.SearchType && moreSearchDataTmp.SearchType == "Sale" ? "فروش" : ""}
                                    {moreSearchDataTmp && moreSearchDataTmp.SearchType && moreSearchDataTmp.SearchType == "Rent" ? "رهن" : ""}
                                    {moreSearchDataTmp && moreSearchDataTmp.SearchType && moreSearchDataTmp.SearchType == "Exchange" ? "معاوضه" : ""}
                                    {moreSearchDataTmp && moreSearchDataTmp.SearchType && moreSearchDataTmp.SearchType == "SalePreSale" ? "پیش فروش" : ""}
                                    {moreSearchDataTmp && moreSearchDataTmp.SearchType && moreSearchDataTmp.SearchType == "Associate" ? "مشارکت" : ""}
                                </Box>

                                <ArrowRightIcon className='rotate-180-minus' />
                            </Box>
                        </Box>

                        {CheckPermissions(userInfo, "search_properties_by_user") ? <SearchByUser moreSearchDataTmp={moreSearchDataTmp} setMoreSearchDataTmp={setMoreSearchDataTmp} handleSetMoreSearchDataTmp={handleSetMoreSearchDataTmp} /> : ""}

                        <Box sx={{ width: '100%' }}>
                            <label htmlFor='meter' className='f-16 text-label'>نوع ملک</label>
                            <Box className="inputs-container" sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }} onClick={handleClickMelkType}>
                                <span>


                                    {moreSearchDataTmp.PropertyTypes && moreSearchDataTmp.PropertyTypes.length ? moreSearchDataTmp.PropertyTypes.map((item, index) => {
                                        return <span key={index}>{item} {index != moreSearchDataTmp.PropertyTypes.length - 1 && "،"} </span>
                                    }) : ""}

                                </span>
                                <ArrowRightIcon className='rotate-180-minus' />
                            </Box>
                        </Box>
                        {
                            searchType == "Sale" ?
                                <Box sx={{ width: '100%' }} key={searchKey}>
                                    <label htmlFor='meter' className='f-16 text-label'>مبلغ خرید <span className='text-gray'>(تومان)</span></label>
                                    <Box className="inputs-container" onClick={handleClickTmpSalePriceModal} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                        <span>
                                            {moreSearchDataTmp.MinSalePrice ? moreSearchDataTmp.MinSalePrice : ""}
                                            {moreSearchDataTmp.MinSalePrice && moreSearchDataTmp.MaxSalePrice ? " , " : ""}
                                            {moreSearchDataTmp.MaxSalePrice ? moreSearchDataTmp.MaxSalePrice : ""}
                                        </span>
                                        <ArrowRightIcon className='rotate-180-minus' />
                                    </Box>
                                </Box> : null}
                        {
                            searchType == "Rent" ?
                                <Box sx={{ width: '100%' }}>
                                    <label htmlFor='meter' className='f-16 text-label'>مبلغ اجاره <span className='text-gray'>(تومان)</span></label>
                                    <Box className="inputs-container" onClick={handleClickTmpRentPriceModal} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                        <span>
                                            {moreSearchDataTmp.MinRentPrice ? parseInt(moreSearchDataTmp.MinRentPrice).toLocaleString() : ""}
                                            {moreSearchDataTmp.MinRentPrice && moreSearchDataTmp.MaxRentPrice ? " , " : ""}
                                            {moreSearchDataTmp.MaxRentPrice ? parseInt(moreSearchDataTmp.MaxRentPrice).toLocaleString() : ""}
                                        </span>
                                        <ArrowRightIcon className='rotate-180-minus' />
                                    </Box>
                                </Box> : null}
                        {
                            searchType == "Rent" ?
                                <Box sx={{ width: '100%' }}>
                                    <label htmlFor='meter' className='f-16 text-label'>مبلغ رهن <span className='text-gray'>(تومان)</span></label>
                                    <Box className="inputs-container" onClick={handleClickTmpRahnPriceModal} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                        <span>
                                            {moreSearchDataTmp.MinMortgagePrice ? parseInt(moreSearchDataTmp.MinMortgagePrice).toLocaleString() : ""}
                                            {moreSearchDataTmp.MinMortgagePrice && moreSearchDataTmp.MaxMortgagePrice ? " , " : ""}
                                            {moreSearchDataTmp.MaxMortgagePrice ? parseInt(moreSearchDataTmp.MaxMortgagePrice).toLocaleString() : ""}
                                        </span>
                                        <ArrowRightIcon className='rotate-180-minus' />
                                    </Box>
                                </Box> : null}
                        <Box sx={{ width: '100%' }}>
                            <label htmlFor='meter' className='f-16 text-label'>زیربنا <span className='text-gray'>(متر)</span></label>
                            <Box className="inputs-container" onClick={handleClickSelectMeterModal} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                <span>
                                    {moreSearchDataTmp.MinInfrastructure ? moreSearchDataTmp.MinInfrastructure : ""}
                                    {moreSearchDataTmp.MinInfrastructure && moreSearchDataTmp.MaxInfrastructure ? " , " : ""}
                                    {moreSearchDataTmp.MaxInfrastructure ? moreSearchDataTmp.MaxInfrastructure : ""}
                                </span>
                                <ArrowRightIcon className='rotate-180-minus' />
                            </Box>
                        </Box>
                        <Box sx={{ width: '100%' }}>
                            <label htmlFor='meter' className='f-16 text-label'>متراژ زمین <span className='text-gray'>(متر)</span></label>
                            <Box className="inputs-container" onClick={handleClickSelectSpaceModal} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                <span>
                                    {moreSearchDataTmp.MinSpace ? moreSearchDataTmp.MinSpace : ""}
                                    {moreSearchDataTmp.MinSpace && moreSearchDataTmp.MaxSpace ? " , " : ""}
                                    {moreSearchDataTmp.MaxSpace ? moreSearchDataTmp.MaxSpace : ""}
                                </span>
                                <ArrowRightIcon className='rotate-180-minus' />
                            </Box>

                        </Box>
                        <Box sx={{ width: '100%' }}>
                            <label htmlFor='meter' className='f-16 text-label'>سال ساخت</label>
                            <Box className="inputs-container" onClick={handleClickSelectYearModal} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                <span>
                                    {moreSearchDataTmp.MinPropertyAgeYear ? moreSearchDataTmp.MinPropertyAgeYear : ""}
                                    {moreSearchDataTmp.MinPropertyAgeYear && moreSearchDataTmp.MaxPropertyAgeYear ? " , " : ""}
                                    {moreSearchDataTmp.MaxPropertyAgeYear ? moreSearchDataTmp.MaxPropertyAgeYear : ""}
                                </span>
                                <ArrowRightIcon className='rotate-180-minus' />
                            </Box>
                        </Box>
                        <Box sx={{ width: '100%' }}>
                            <label className='f-16 text-label'>طبقه</label>
                            <Box className="inputs-container" sx={{ width: 'auto', mt: 1, overflow: "hidden" }}>
                                <Box className="numbers-scroll" id="floorNo-container" sx={{ width: '100%', display: 'flex', direction: 'ltr', justifyContent: 'start', textAlign: 'center', overflow: "auto" }}>
                                    {
                                        Array.apply(0, Array(51)).map(function (x, i) {
                                            return <Box key={i}>
                                                <input type="checkbox" name='floor' id={`floor${i - 25}`} value={i - 25} checked={moreSearchDataTmp.StoreyNo && moreSearchDataTmp.StoreyNo.includes((i - 25).toString())} onChange={e => handleSetMoreSearchDataTmp("StoreyNo", e.target.value, true, true)} className="d-none NumberCheck" />
                                                <label htmlFor={`floor${i - 25}`} className='NumberLabel'>
                                                    {i - 25 == 0 ? <span style={{ fontSize: "10px" }}>همکف</span> : i - 25}
                                                </label>
                                            </Box>
                                        })
                                    }
                                </Box>
                            </Box>
                        </Box>
                        {/* <Box sx={{ width: '100%' }}>
                            <label className='f-16 text-label'>طبقه</label>
                            <Box className="inputs-container" sx={{ width: 'auto', mt: 1, display: 'flex', direction: 'ltr', justifyContent: 'space-around', textAlign: 'center' }}>
                                {
                                    Array.apply(0, Array(10)).map(function (x, i) {
                                        return <Box key={i}>
                                            <input type="radio" name='floor' id={`floor${i - 2}`} value={i - 2} className="d-none NumberCheck" onChange={e => handleSetMoreSearchDataTmp("StoreyNo", e.target.value)} />
                                            <label htmlFor={`floor${i - 2}`} className='NumberLabel'>
                                                {i - 2}
                                            </label>
                                        </Box>
                                    })
                                }
                            </Box>
                        </Box> */}
                        <Box sx={{ width: '100%' }}>
                            <label htmlFor='meter' className='f-16 text-label'>نوع سند</label>
                            <Box className="inputs-container" onClick={handleClickOpenSanadModal} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                <span>

                                    {moreSearchDataTmp.CertificateTypes && moreSearchDataTmp.CertificateTypes.length ? moreSearchDataTmp.CertificateTypes.map((item, index) => {
                                        return <span key={index}>{item} {index != moreSearchDataTmp.CertificateTypes.length - 1 && "،"} </span>
                                    }) : ""}

                                </span>
                                <ArrowRightIcon className='rotate-180-minus' />
                            </Box>
                        </Box>
                        <Box sx={{ width: '100%' }}>
                            <label htmlFor='meter' className='f-16 text-label'>نوع کاربری</label>
                            <Box className="inputs-container" onClick={handleClickOpenUserTypeModal} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                <span>

                                    {moreSearchDataTmp.UsageTypes && moreSearchDataTmp.UsageTypes.length ? moreSearchDataTmp.UsageTypes.map((item, index) => {
                                        return <span key={index}>{item} {index != moreSearchDataTmp.UsageTypes.length - 1 && "،"} </span>
                                    }) : ""}

                                </span>
                                <ArrowRightIcon className='rotate-180-minus' />
                            </Box>
                        </Box>
                        <Box sx={{ width: '100%' }}>
                            <label className='f-16 text-label'>تعداد اتاق ها</label>
                            <Box className="inputs-container" sx={{ width: 'auto', mt: 1, overflow: "hidden" }}>
                                <Box className="numbers-scroll" sx={{ width: '100%', display: 'flex', direction: 'ltr', justifyContent: 'start', textAlign: 'center', overflow: "auto" }}>

                                    {
                                        Array.apply(0, Array(51)).map(function (x, i) {
                                            return <Box key={i}>
                                                <input type="checkbox" name='room' id={`room${i}`} value={i} checked={moreSearchDataTmp.MaxStoreyCount && moreSearchDataTmp.MaxStoreyCount.includes(i.toString())} onChange={e => handleSetMoreSearchDataTmp("MaxStoreyCount", e.target.value, true, true)} className="d-none NumberCheck" />
                                                <label htmlFor={`room${i}`} className='NumberLabel'>
                                                    {i}
                                                </label>
                                            </Box>
                                        })
                                    }
                                </Box>
                            </Box>
                        </Box>
                        <Box>
                            <label className='f-16'>ویژگی های اصلی</label>
                            <Grid container spacing={1} sx={{ mt: 1 }}>

                                <Grid item xs={4}>

                                    <input type="checkbox" id="major1" className="d-none typeCheck" value="انباری" name='major' onChange={(e) => handlBooleanMoreSearchDataTemp("Store", e.target.value)} />
                                    <label htmlFor="major1" className='typeLabel w-auto'>
                                        <span className='flex-1'>انباری</span>
                                    </label>
                                </Grid>
                                <Grid item xs={4}>
                                    <input type="checkbox" id="major2" className="d-none typeCheck" value="آسانسور" name='major' onChange={(e) => handlBooleanMoreSearchDataTemp("Elevator", e.target.value)} />
                                    <label htmlFor="major2" className='typeLabel w-auto'>
                                        <span className='flex-1'>آسانسور</span>
                                    </label>
                                </Grid>
                                <Grid item xs={4}>
                                    <input type="checkbox" id="major3" className="d-none typeCheck" value="پارکینگ" name='major' onChange={(e) => handlBooleanMoreSearchDataTemp("Parking", e.target.value)} />
                                    <label htmlFor="major3" className='typeLabel w-auto'>
                                        <span className='flex-1'>پارکینگ</span>
                                    </label>

                                </Grid>
                            </Grid>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography>موارد بایگانی شده</Typography>
                            <Switch checked={moreSearchDataTmp["IsArchived"] == "1" ? true : false} onChange={e => handlBooleanMoreSearchDataTemp("IsArchived", e.target.value)} />
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography>موارد موارد دریافتی از پایش</Typography>
                            <Switch />
                        </Box>
                        <Box>

                            <Box className="inputs-container" sx={{ width: 'auto', mt: 1 }}>
                                <InputBase id='meter' placeholder='جستجو در توضیحات یا آدرس' onChange={e => handleSetMoreSearchDataTmp("SearchKeys", e.target.value, true)} />
                            </Box>
                        </Box>
                    </Box>
                    <Button
                        onClick={handleSearchMore}
                        className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>مشاهده نتایج</Button>
                </Box>
            </Dialog>}

            {melkTypeModal && <Dialog className="dialog-box"
                fullScreen
                open={melkTypeModal}
                onClose={handleMelkTypeClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>
                        {/* <Button autoFocus color="inherit">
                            حذف فیلتر ها
                        </Button> */}
                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                            {/* انتخاب محدوده */}
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleMelkTypeClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>

                    </Toolbar>
                </AppBar>

                <Box className='tab-container' sx={{ px: 2 }}>
                    <Box>
                        <Tabs value={melkTabValue} onChange={handleChangeMelkTabValue} className="inputs-container" sx={{ width: 'auto', p: 0, display: 'flex' }} aria-label="basic tabs example">
                            <Tab icon={<CityIcon />} sx={{ flex: 1 }} iconPosition="start" label="شهری" {...a11yProps(0)} />
                            <Tab icon={<SettingIcon />} sx={{ flex: 1 }} iconPosition="start" label="صنعتی و کشاورزی" {...a11yProps(1)} />
                        </Tabs>
                    </Box>
                    <TabPanel value={melkTabValue} index={0}>
                        <Grid container spacing={5} className='gap-top-20' sx={{ pt: 2 }}>
                            {data.propertyType.cities.map((city, index) => (
                                <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }} key={index}>
                                    <input type="checkbox" name='propertyType' value={city} id={`item${index}`} className="d-none typeCheck" checked={moreSearchDataTmp.PropertyTypes && moreSearchDataTmp.PropertyTypes != "" && moreSearchDataTmp.PropertyTypes.includes(city)} onChange={(e) => handleSetMoreSearchDataTmp("PropertyTypes", e.target.value, true, true, true)} />
                                    <label htmlFor={`item${index}`} className='typeLabel w-100'>
                                        <span className="flex-1">{city}</span>
                                    </label>
                                </Grid>
                            ))}
                            {/* {data.propertyType.map((melkItem, index) => (
                                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                        <input type="checkbox" id={`item${index}`} className="d-none typeCheck" />
                                        <label htmlFor={`item${index}`} className='typeLabel'>
                                            {melkItem}
                                        </label>
                                    </Grid>
                                ))} */}

                        </Grid>
                    </TabPanel>
                    <TabPanel value={melkTabValue} index={1}>
                        <Grid container spacing={5} className='gap-top-20' sx={{ pt: 2 }}>
                            {data.propertyType.industrial.map((industry, index) => (
                                <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                    <input type="checkbox" name='propertyType' value={industry} id={`item${index}`} className="d-none typeCheck" checked={moreSearchDataTmp.PropertyTypes && moreSearchDataTmp.PropertyTypes != "" && moreSearchDataTmp.PropertyTypes.includes(industry)} onChange={(e) => handleSetMoreSearchDataTmp("PropertyTypes", e.target.value, true, true, true)} />
                                    <label htmlFor={`item${index}`} className='typeLabel w-100'>
                                        <span className="flex-1">{industry}</span>
                                    </label>
                                </Grid>
                            ))}
                        </Grid>
                    </TabPanel>
                </Box>
                <Button
                    onClick={handleMelkTypeClose}
                    className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
            </Dialog>}

            {tmpSalePriceModal && <Dialog className="dialog-box"
                fullScreen
                open={tmpSalePriceModal}
                onClose={handleSaleTmpSalePriceModalClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">

                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleSaleTmpSalePriceModalClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleZoneModalClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box>
                    <Grid container spacing={2} sx={{ px: 2 }}>
                        <Grid item xs={6}>
                            <TextField
                                label=""
                                placeholder='حداقل'
                                name="sale-price"
                                pattern="(\d)+"
                                id="formatted-numberformat-input"
                                className='remove-underline dir-ltr text-input-1 w-100'
                                InputProps={{
                                    inputComponent: NumericFormatCustom,
                                }}
                                variant="standard"
                                onChange={(e) => {
                                    handleSetMoreSearchDataTmp("MinSalePrice", e.target.value)
                                }}
                                value={moreSearchDataTmp.MinSalePrice}
                                onFocus={() => setShowMeterItem(1)}
                            />
                            {
                                showMeterItem == 1 ?
                                    <Box sx={{ mt: 2 }}>
                                        {
                                            priceItems.map((item, index) => {
                                                return <Box className="price-item" key={index}>
                                                    <input type="radio" name="minPrice" id={`min-${index}`} className="d-none" onChange={() => {
                                                        handleSetMoreSearchDataTmp("MinSalePrice", item.value)
                                                        setShowMeterItem(2)
                                                    }} />
                                                    <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                        <label htmlFor={`min-${index}`} className='w-100 d-block'>
                                                            {item.title}
                                                        </label>
                                                    </Button>
                                                </Box>
                                            })
                                        }
                                    </Box>
                                    : ''
                            }
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                label=""
                                placeholder='حداکثر'
                                name="sale-price"
                                pattern="(\d)+"
                                id="formatted-numberformat-input"
                                className='remove-underline dir-ltr text-input-1 w-100'
                                InputProps={{
                                    inputComponent: NumericFormatCustom,
                                }}
                                variant="standard"
                                onFocus={() => setShowMeterItem(2)}
                                value={moreSearchDataTmp.MaxSalePrice}
                                onChange={(e) => {
                                    handleSetMoreSearchDataTmp("MaxSalePrice", e.target.value)
                                }}
                            />
                            {
                                showMeterItem == 2 ?
                                    <Box sx={{ mt: 2 }}>
                                        {
                                            priceItems.map((item, index) => {
                                                return <Box className="price-item" key={index}>
                                                    <input type="radio" name="maxPrice" id={`max-${index}`} className="d-none" onChange={() => {
                                                        handleSetMoreSearchDataTmp("MaxSalePrice", item.value)
                                                        handleSaleTmpSalePriceModalClose()
                                                    }} />
                                                    <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                        <label htmlFor={`max-${index}`} className='w-100 d-block'>
                                                            {item.title}
                                                        </label>
                                                    </Button>
                                                </Box>
                                            })
                                        }
                                    </Box>
                                    : ''
                            }
                        </Grid>
                    </Grid>
                </Box>
                <Button
                    onClick={handleSaleTmpSalePriceModalClose}
                    className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
            </Dialog>}

            {selectMeterModal && <Dialog className="dialog-box"
                fullScreen
                open={selectMeterModal}
                onClose={handleSelectMeterModalClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">

                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleSelectMeterModalClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleZoneModalClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box>
                    <Grid container spacing={2} sx={{ px: 2 }}>
                        <Grid item xs={6}>
                            <TextField
                                label=""
                                placeholder='حداقل'
                                name="sale-price"
                                pattern="(\d)+"
                                id="formatted-numberformat-input"
                                className='remove-underline dir-ltr text-input-1 w-100'
                                InputProps={{
                                    inputComponent: NumericFormatCustom,
                                }}
                                variant="standard"
                                onFocus={() => setShowPriceItem(1)}
                                value={moreSearchDataTmp.MinInfrastructure}
                                onChange={(e) => handleSetMoreSearchDataTmp("MinInfrastructure", e.target.value)}
                            />
                            {
                                showPriceItem == 1 ?
                                    <Box sx={{ mt: 2 }}>
                                        {
                                            meterItems.map((item, index) => {
                                                return <Box className="price-item" key={index}>
                                                    <input type="radio" name="minMeter" id={`min-${index}`} className="d-none" onChange={() => {
                                                        handleSetMoreSearchDataTmp("MinInfrastructure", item)
                                                        setShowPriceItem(2)
                                                    }} />
                                                    <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                        <label htmlFor={`min-${index}`} className='w-100 d-block'>
                                                            {item} متر
                                                        </label>
                                                    </Button>
                                                </Box>
                                            })
                                        }
                                    </Box>
                                    : ''
                            }
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                label=""
                                placeholder='حداکثر'
                                name="sale-price"
                                pattern="(\d)+"
                                id="formatted-numberformat-input"
                                className='remove-underline dir-ltr text-input-1 w-100'
                                InputProps={{
                                    inputComponent: NumericFormatCustom,
                                }}
                                variant="standard"
                                onFocus={() => setShowPriceItem(2)}
                                value={moreSearchDataTmp.MaxInfrastructure}
                                onChange={(e) => handleSetMoreSearchDataTmp("MaxInfrastructure", e.target.value)}
                            />
                            {
                                showPriceItem == 2 ?
                                    <Box sx={{ mt: 2 }}>
                                        {
                                            meterItems.map((item, index) => {
                                                return <Box className="price-item" key={index}>
                                                    <input type="radio" name="maxMeter" id={`max-${index}`} className="d-none" onChange={() => {
                                                        handleSetMoreSearchDataTmp("MaxInfrastructure", item)
                                                        handleSelectMeterModalClose()
                                                    }} />
                                                    <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                        <label htmlFor={`max-${index}`} className='w-100 d-block'>
                                                            {item} متر
                                                        </label>
                                                    </Button>
                                                </Box>
                                            })
                                        }
                                    </Box>
                                    : ''
                            }
                        </Grid>
                    </Grid>
                </Box>
                <Button
                    onClick={handleSelectMeterModalClose}
                    className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
            </Dialog>}

            {selectSpaceModal && <Dialog className="dialog-box"
                fullScreen
                open={selectSpaceModal}
                onClose={handleSelectSpaceSpaceClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">

                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleSelectSpaceSpaceClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleZoneModalClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box>
                    <Grid container spacing={2} sx={{ px: 2 }}>
                        <Grid item xs={6}>
                            <TextField
                                label=""
                                placeholder='حداقل'
                                name="sale-price"
                                pattern="(\d)+"
                                id="formatted-numberformat-input"
                                className='remove-underline dir-ltr text-input-1 w-100'
                                InputProps={{
                                    inputComponent: NumericFormatCustom,
                                }}
                                variant="standard"
                                value={moreSearchDataTmp.MinSpace}
                                onFocus={() => setShowPriceItem(1)}
                                onChange={(e) => handleSetMoreSearchDataTmp("MinSpace", e.target.value)}
                            />
                            {
                                showPriceItem == 1 ?
                                    <Box sx={{ mt: 2 }}>
                                        {
                                            meterItems.map((item, index) => {
                                                return <Box className="price-item" key={index}>
                                                    <input type="radio" name="minMeter" id={`min-${index}`} className="d-none" onChange={() => {
                                                        handleSetMoreSearchDataTmp("MinSpace", item)
                                                        setShowPriceItem(2)
                                                    }} />
                                                    <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                        <label htmlFor={`min-${index}`} className='w-100 d-block'>
                                                            {item} متر
                                                        </label>
                                                    </Button>
                                                </Box>
                                            })
                                        }
                                    </Box>
                                    : ''
                            }
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                label=""
                                placeholder='حداکثر'
                                name="sale-price"
                                pattern="(\d)+"
                                id="formatted-numberformat-input"
                                className='remove-underline dir-ltr text-input-1 w-100'
                                InputProps={{
                                    inputComponent: NumericFormatCustom,
                                }}
                                variant="standard"
                                value={moreSearchDataTmp.MaxSpace}
                                onFocus={() => setShowPriceItem(2)}
                                onChange={(e) => handleSetMoreSearchDataTmp("MaxSpace", e.target.value)}
                            />
                            {
                                showPriceItem == 2 ?
                                    <Box sx={{ mt: 2 }}>
                                        {
                                            meterItems.map((item, index) => {
                                                return <Box className="price-item" key={index}>
                                                    <input type="radio" name="maxMeter" id={`max-${index}`} className="d-none" onChange={() => {
                                                        handleSetMoreSearchDataTmp("MaxSpace", item)
                                                        handleSelectSpaceSpaceClose()
                                                    }} />
                                                    <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                        <label htmlFor={`max-${index}`} className='w-100 d-block'>
                                                            {item} متر
                                                        </label>
                                                    </Button>
                                                </Box>
                                            })
                                        }
                                    </Box>
                                    : ''
                            }
                        </Grid>
                    </Grid>
                </Box>
                <Button
                    onClick={handleSelectSpaceSpaceClose}
                    className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
            </Dialog>
            }


            {selectYearModal && <Dialog className="dialog-box"
                fullScreen
                open={selectYearModal}
                onClose={handleSelectYearModalClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">

                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleSelectYearModalClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleZoneModalClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box>
                    <Grid container spacing={2} sx={{ px: 2 }}>
                        <Grid item xs={6}>
                            <TextField
                                label=""
                                placeholder='حداقل'
                                name="sale-price"
                                pattern="(\d)+"
                                id="formatted-numberformat-input"
                                className='remove-underline dir-ltr text-input-1 w-100'

                                variant="standard"
                                onFocus={() => setShowYearItem(1)}
                                value={moreSearchDataTmp.MinPropertyAgeYear}
                                onChange={(e) => handleSetMoreSearchDataTmp("MinPropertyAgeYear", e.target.value)}
                            />
                            {
                                showYearItem == 1 ?
                                    <Box sx={{ mt: 2 }}>
                                        {
                                            yearDates.map((item, index) => {
                                                return <Box className="price-item" key={index}>
                                                    <input type="radio" name="minYear" id={`year-min-${index}`} className="d-none" onChange={() => {
                                                        handleSetMoreSearchDataTmp("MinPropertyAgeYear", item)
                                                        setShowYearItem(2)
                                                    }} />
                                                    <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                        <label htmlFor={`year-min-${index}`} className='w-100 d-block'>
                                                            {item} ({parseInt(nowDate) - parseInt(item)} سال)
                                                        </label>
                                                    </Button>
                                                </Box>
                                            })
                                        }
                                    </Box>
                                    : ''
                            }
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                label=""
                                placeholder='حداکثر'
                                name="sale-price"
                                pattern="(\d)+"
                                id="formatted-numberformat-input"
                                className='remove-underline dir-ltr text-input-1 w-100'

                                variant="standard"
                                onFocus={() => setShowYearItem(2)}
                                value={moreSearchDataTmp.MaxPropertyAgeYear}
                                onChange={(e) => handleSetMoreSearchDataTmp("MaxPropertyAgeYear", e.target.value)}
                            />
                            {
                                showYearItem == 2 ?
                                    <Box sx={{ mt: 2 }}>
                                        {
                                            yearDates.map((item, index) => {
                                                return <Box className="price-item" key={index}>
                                                    <input type="radio" name="maxYear" id={`year-max-${index}`} className="d-none" onChange={() => {
                                                        handleSetMoreSearchDataTmp("MaxPropertyAgeYear", item)
                                                        handleSelectYearModalClose()
                                                    }} />
                                                    <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                        <label htmlFor={`year-max-${index}`} className='w-100 d-block'>
                                                            {item} ({parseInt(nowDate) - parseInt(item)} سال)
                                                        </label>
                                                    </Button>
                                                </Box>
                                            })
                                        }
                                    </Box>
                                    : ''
                            }
                        </Grid>
                    </Grid>
                </Box>
                <Button
                    onClick={handleSelectYearModalClose}
                    className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
            </Dialog>}

            {openSanadModal && <Dialog className="dialog-box"
                fullScreen
                open={openSanadModal}
                onClose={handleCloseSanadModal}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                            انتخاب کنید
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleCloseSanadModal}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px' }}>
                    <Box className="inputs-container" sx={{ display: "flex", width: 'auto', alignItems: "center" }}>
                        <InputBase placeholder='' className='flex-1' />
                        <IconButton>
                            <SreachIcon />
                        </IconButton>
                    </Box>
                    <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>
                        <Grid container spacing={4}>
                            {data.typeDoc.map((doc, index) => (
                                <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                    <input type="checkbox" id={`sanad${index}`} className="d-none typeCheck" value={doc} checked={moreSearchDataTmp.CertificateTypes && moreSearchDataTmp.CertificateTypes.includes(doc)} onChange={e => handleSetMoreSearchDataTmp("CertificateTypes", e.target.value, false, true)} />
                                    <label htmlFor={`sanad${index}`} className='typeLabel'>
                                        {doc}
                                    </label>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                </Box>
                <Button
                    onClick={handleCloseSanadModal}
                    className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
            </Dialog>}

            {openUserTypeModal && <Dialog className="dialog-box"
                fullScreen
                open={openUserTypeModal}
                onClose={handleCloseOpenUserTypeModal}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                            نوع کاربری
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleCloseOpenUserTypeModal}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px' }}>
                    <Box sx={{ display: 'flex', gap: 1, flexDirection: 'column' }}>
                        <Grid container spacing={5} sx={{ pt: 2 }} className='gap-top-20'>
                            {data.AccountType.map((AccountTypeKey, index) => (
                                <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index} >
                                    <input type="checkbox" id={`AccountType${index}`} value={AccountTypeKey} className="d-none typeCheck" checked={moreSearchDataTmp.UsageTypes && moreSearchDataTmp.UsageTypes.includes(AccountTypeKey)} onChange={e => handleSetMoreSearchDataTmp("UsageTypes", e.target.value, false, true)} />
                                    <label htmlFor={`AccountType${index}`} className='typeLabel'>
                                        {AccountTypeKey}
                                    </label>
                                </Grid>
                            ))}

                        </Grid>
                    </Box>
                </Box>
                <Button
                    onClick={handleCloseOpenUserTypeModal}
                    className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
            </Dialog>}

            {opanHistoryModal && <Dialog className="dialog-box"
                fullScreen
                open={opanHistoryModal}
                onClose={handleHistoryModalClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} component="div">
                            تاریخچه جستجو
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleHistoryModalClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box sx={{ px: 2, mt: 1, color: '#8F8F8F', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '0px' }}>

                    {/* <Grid container spacing={5} sx={{ pt: 2 }} className='gap-top-20'>
                            {data.AccountType.map((AccountTypeKey, index) => (
                                <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index} >
                                    <input type="checkbox" id={`AccountType${index}`} value={AccountTypeKey} className="d-none typeCheck" checked={moreSearchDataTmp.UsageTypes && moreSearchDataTmp.UsageTypes.includes(AccountTypeKey)} onChange={e => handleSetMoreSearchDataTmp("UsageTypes", e.target.value, false, true)} />
                                    <label htmlFor={`AccountType${index}`} className='typeLabel'>
                                        {AccountTypeKey}
                                    </label>
                                </Grid>
                            ))}

                        </Grid> */}
                    {
                        Object.keys(historyItems).length ?
                            Object.keys(historyItems).map((item, index) => {
                                return <Button key={index} className='history-item' onClick={() => {
                                    historyItems[item].type == "property" && navigation(`/property/${item}`)
                                    historyItems[item].type == "applicant" && navigation(`/applicant/${item}`)
                                    handleHistoryModalClose()
                                }}>
                                    <Box sx={{textAlign: 'right', display: "flex", width: "100%", alignItems: "center", justifyContent: 'space-between', gap: "7px", paddingTop: "7px", paddingBottom: "7px" }}>
                                        {historyItems[item].title}
                                        <IconButton
                                            onClick={(e) => {
                                                handleRemoveFromHistory(item)
                                                e.stopPropagation();
                                            }}
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                    </Box>

                                </Button>
                            })
                            : <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box>
                    }

                </Box>
                {/* <Button
                    onClick={handleHistoryModalClose}
                    className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button> */}
            </Dialog>}


        </>
    );
}

export default Dashboard;